var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/dayjs/dayjs.min.js"(exports, module) {
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: /* @__PURE__ */ __name(function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      }, "ordinal") }, m = /* @__PURE__ */ __name(function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, "m"), v = { s: m, z: /* @__PURE__ */ __name(function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, "z"), m: /* @__PURE__ */ __name(function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, "t"), a: /* @__PURE__ */ __name(function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, "a"), p: /* @__PURE__ */ __name(function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, "p"), u: /* @__PURE__ */ __name(function(t2) {
        return void 0 === t2;
      }, "u") }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = /* @__PURE__ */ __name(function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, "S"), w = /* @__PURE__ */ __name(function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, "t"), O = /* @__PURE__ */ __name(function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, "O"), b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        __name(M2, "M");
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = /* @__PURE__ */ __name(function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, "l"), $2 = /* @__PURE__ */ __name(function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, "$"), y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = /* @__PURE__ */ __name(function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          }, "y");
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = /* @__PURE__ */ __name(function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, "h"), d2 = /* @__PURE__ */ __name(function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, "d"), $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, function(t3, r3) {
            return r3 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = /* @__PURE__ */ __name(function() {
            return b.m(y2, m3);
          }, "D");
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k = _.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// src/atoms/elevation.ts
var elevation = {
  low: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.08)" }
  },
  high: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.16)" }
  }
};

// src/atoms/radius.ts
var radius = {
  nonInteractive: "0",
  interactiveCompact: "4px",
  interactive: "8px",
  container: "0",
  round: "50%"
};

// src/atoms/spacing.ts
var spacing = {
  s4: "4px",
  s8: "8px",
  s16: "16px",
  s24: "24px",
  s32: "32px",
  s48: "48px"
};

// src/atoms/typography.ts
import { createGetFontVariationSettings } from "@instacart/ids-core";
var INSTACART_SANS_FONT_FAMILY = "Instacart Sans";
var INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS = `"${INSTACART_SANS_FONT_FAMILY}", Helvetica, Arial, sans-serif`;
var FONT_VARIATION_CONSTANTS = {
  wght: {
    normal: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
  },
  opsz: {
    // These values are encoded into the static versions of our Instacart Sans
    // fonts. With our variable fonts we can just change this axis of variation
    // to get the same effect as changing font families.
    headline: 48,
    // Maps to Instacart Sans Headline
    subhead: 32,
    // Maps to Instacart Sans Subhead
    text: 8
    // Maps to Instacart Sans Text
  }
};
var getVariationSettings = createGetFontVariationSettings(FONT_VARIATION_CONSTANTS);
var typography = {
  headline: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 28,
    lineHeight: "32px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  title: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 24,
    lineHeight: "28px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  subtitle: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 18,
    lineHeight: "22px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  bodyEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyStrikethrough: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })), {
    textDecoration: "line-through"
  }),
  bodyLink: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })), {
    textDecoration: "underline"
  }),
  accentRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  accentEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" }))
};

// src/atoms/theme/TDS_DEFAULT_COLORS.ts
var TDS_DEFAULT_COLORS = {
  colors: {
    systemGrayscale00: "#FFFFFF",
    systemGrayscale10: "#F6F7F8",
    systemGrayscale20: "#E8E9EB",
    systemGrayscale30: "#C7C8CD",
    systemGrayscale60: "#56595E",
    systemGrayscale80: "#242529",
    systemDetrimentalRegular: "#DE3534",
    systemDetrimentalDark: "#BB1C1B",
    systemDetrimentalExtraDark: "#AC1615",
    systemDetrimentalLight: "#FEF0F0",
    systemSuccessRegular: "#108910",
    systemSuccessDark: "#0D720D",
    systemSuccessExtraDark: "#0A610A",
    systemSuccessLight: "#E9FBE9",
    systemAlertRegular: "#F89F1A",
    systemAlertLight: "#FFFADF",
    systemInfoRegular: "#242529",
    systemInfoLight: "#FCF7F1",
    brandPrimaryRegular: "#0A5546",
    brandPrimaryDark: "#003D29",
    brandPrimaryExtraDark: "#001810",
    brandPrimaryLight: "#ECF6F3",
    brandPrimaryExtraLight: "#F5FBF9",
    dataCategory1: "#01A3AC",
    dataCategory2: "#5D5FEF",
    dataCategory3: "#7008A1",
    dataCategory4: "#EC269A",
    dataCategory5: "#003D29",
    dataSequentialSet1_1: "#01A3AC",
    dataSequentialSet1_2: "#1DBEC7",
    dataSequentialSet1_3: "#22D7E2",
    dataSequentialSet1_4: "#4BEAF3",
    dataSequentialSet1_5: "#75F7FF",
    dataSequentialSet2_1: "#5D5FEF",
    dataSequentialSet2_2: "#7C7DFF",
    dataSequentialSet2_3: "#9899FF",
    dataSequentialSet2_4: "#AFB0FF",
    dataSequentialSet2_5: "#CACFFF",
    dataSequentialSet3_1: "#7008A1",
    dataSequentialSet3_2: "#9B20D6",
    dataSequentialSet3_3: "#BE48F6",
    dataSequentialSet3_4: "#D479FF",
    dataSequentialSet3_5: "#E6B0FF",
    dataSequentialSet4_1: "#EC269A",
    dataSequentialSet4_2: "#FA54B5",
    dataSequentialSet4_3: "#FF7EC9",
    dataSequentialSet4_4: "#FFA6DA",
    dataSequentialSet4_5: "#FFD0EC",
    dataSequentialSet5_1: "#003D29",
    dataSequentialSet5_2: "#075D40",
    dataSequentialSet5_3: "#0A8C5C",
    dataSequentialSet5_4: "#23BF90",
    dataSequentialSet5_5: "#7DE4B9"
  }
};

// src/atoms/theme/TdsProvider.tsx
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { useContext, useMemo } from "react";
import { MantineProvider } from "@mantine/core";
import { CachedThemeContext, CachedThemeProvider } from "@instacart/ids-core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { Fragment, jsx } from "@emotion/react/jsx-runtime";
function TdsProvider({
  children,
  theme: themeOverride,
  idsColorPrecedence
}) {
  const theme = useMemo(
    () => ({
      tdsTheme: themeOverride != null ? themeOverride : TDS_DEFAULT_COLORS
    }),
    [themeOverride]
  );
  return /* @__PURE__ */ jsx(EmotionThemeProvider, { theme, children: /* @__PURE__ */ jsx(IdsCacheUpdater, { idsColorPrecedence, children: /* @__PURE__ */ jsx(TdsMantineProvider, { children }) }) });
}
__name(TdsProvider, "TdsProvider");
function TdsMantineProvider({ children }) {
  return /* @__PURE__ */ jsx(MantineProvider, { children });
}
__name(TdsMantineProvider, "TdsMantineProvider");
function IdsCacheUpdater({
  children,
  idsColorPrecedence
}) {
  const cachedThemeContext = useContext(CachedThemeContext);
  if (cachedThemeContext === void 0) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(CachedThemeProvider, { idsColorPrecedence, children });
}
__name(IdsCacheUpdater, "IdsCacheUpdater");

// src/atoms/theme/useTheme.ts
import { useTheme as emotionUseTheme } from "@emotion/react";
function useTheme() {
  const themeObject = emotionUseTheme();
  if (!("tdsTheme" in themeObject)) {
    throw new Error(`No <TdsProvider> in scope. Please add a <TdsProvider> to your component tree.`);
  }
  return themeObject.tdsTheme;
}
__name(useTheme, "useTheme");

// src/molecules/Alert/Alert.tsx
import { ApprovedIcon, InformationIcon, NotificationIcon, IssueIcon } from "@instacart/ids-core";
import { useState, forwardRef as forwardRef5 } from "react";

// src/molecules/CloseButton/CloseButton.tsx
import { CloseIcon } from "@instacart/ids-core";

// src/molecules/ButtonBase/ButtonBase.tsx
import { Button } from "@mantine/core";

// src/molecules/LoadingDots/LoadingDots.tsx
import { keyframes } from "@emotion/react";
import { A11Y } from "@instacart/ids-core";
import { Fragment as Fragment2, jsx as jsx2, jsxs } from "@emotion/react/jsx-runtime";
var defaultLoadingDotSize = "calc(1em - 5px)";
var defaultLoadingDotGap = "calc(0.75em - 3px)";
function LoadingDots({
  children,
  loadingDotSize,
  loadingDotGap,
  color
}) {
  const loadingDots = keyframes`
    0%, {
      opacity: 1;
    }

    33% {
      opacity: 0.6;
    }

    66%, 100% {
      opacity: 0.3;
    }
  `;
  const dot = {
    width: loadingDotSize != null ? loadingDotSize : defaultLoadingDotSize,
    height: loadingDotSize != null ? loadingDotSize : defaultLoadingDotSize,
    animation: `${loadingDots} 1500ms infinite linear`,
    borderRadius: "50%",
    backgroundColor: color || "currentcolor",
    opacity: 0.5,
    flex: "0 0 auto"
  };
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsxs(
      "span",
      {
        "aria-hidden": "true",
        "data-testid": "loading-dots",
        css: {
          display: "flex",
          gap: loadingDotGap != null ? loadingDotGap : defaultLoadingDotGap,
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          userSelect: "none"
        },
        children: [
          /* @__PURE__ */ jsx2("span", { css: [dot, { animationDelay: "0ms" }] }),
          /* @__PURE__ */ jsx2("span", { css: [dot, { animationDelay: `500ms` }] }),
          /* @__PURE__ */ jsx2("span", { css: [dot, { animationDelay: `1000ms` }] })
        ]
      }
    ),
    /* @__PURE__ */ jsx2("span", { css: A11Y.visuallyHidden, children })
  ] });
}
__name(LoadingDots, "LoadingDots");

// src/molecules/ButtonBase/ButtonBase.tsx
import { forwardRef } from "react";
import { jsx as jsx3, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var ButtonBase = forwardRef((props, ref) => {
  const theme = useTheme();
  const _a = props, {
    disabled,
    loading,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    compact,
    onClick,
    styles: styles3,
    fullWidth,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "disabled",
    "loading",
    "leftIcon",
    "rightIcon",
    "compact",
    "onClick",
    "styles",
    "fullWidth",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const {
    activeColor,
    backgroundColor,
    borderColor,
    textColor,
    disabledTextColor,
    dotLoaderColor,
    focusColor,
    hoverColor,
    hoverTextColor,
    disabledColor,
    padding = compact ? `${spacing.s4} ${spacing.s16}` : `${spacing.s8} ${spacing.s16}`,
    minWidth = "96px",
    minHeight = compact ? "28px" : "40px",
    loadingDotSize = 8,
    loadingDotGap = 4,
    iconGap = spacing.s8,
    iconSize = compact ? 16 : 24,
    borderRadius = compact ? radius.interactiveCompact : radius.interactive
  } = styles3;
  const width = fullWidth ? "100%" : "auto";
  const textTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  return /* @__PURE__ */ jsxs2(
    Button,
    __spreadProps(__spreadValues({
      ref,
      disabled,
      leftSection: LeftIcon && /* @__PURE__ */ jsx3(
        LeftIcon,
        {
          size: iconSize,
          fill: disabled ? theme.colors[disabledTextColor] : theme.colors[textColor]
        }
      ),
      rightSection: RightIcon && /* @__PURE__ */ jsx3(
        RightIcon,
        {
          size: iconSize,
          fill: disabled ? theme.colors[disabledTextColor] : theme.colors[textColor]
        }
      ),
      styles: {
        // 'inner' refers to the Mantine Button's inner span
        // We apply these styles so any left or right icons are aligned properly
        inner: {
          display: "flex",
          justifyContent: "center",
          gap: iconGap
        },
        section: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        label: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      },
      css: {
        backgroundColor: backgroundColor ? theme.colors[backgroundColor] : "transparent",
        border: !disabled && borderColor ? `1px solid ${theme.colors[borderColor]}` : "none",
        borderRadius,
        cursor: "pointer",
        padding,
        position: "relative",
        minHeight,
        minWidth,
        width,
        color: theme.colors[textColor],
        "&:hover": {
          backgroundColor: theme.colors[hoverColor],
          color: theme.colors[hoverTextColor]
        },
        "&:active": {
          backgroundColor: theme.colors[activeColor]
        },
        ":focus-visible": {
          backgroundColor: theme.colors[hoverColor],
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "2px"
        },
        ":disabled": {
          backgroundColor: theme.colors[disabledColor],
          color: theme.colors[disabledTextColor],
          cursor: "not-allowed"
        }
      },
      style: __spreadValues({}, loading && {
        backgroundColor: theme.colors[activeColor],
        cursor: "not-allowed"
      }),
      onClick: loading || disabled ? void 0 : onClick,
      unstyled: true
    }, rest), {
      children: [
        loading && /* @__PURE__ */ jsx3(
          "div",
          {
            css: {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.colors[activeColor],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "none",
              borderRadius
            },
            children: /* @__PURE__ */ jsx3(
              LoadingDots,
              {
                loadingDotSize,
                loadingDotGap,
                color: theme.colors[dotLoaderColor]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx3("span", { css: __spreadValues({ display: "flex" }, textTypography), children: props.children })
      ]
    })
  );
});
ButtonBase.displayName = "ButtonBase";

// src/layout/Flex/Flex.tsx
import { Flex as IdsFlex } from "@instacart/ids-core";
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
function Row(_a) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx4(IdsFlex, __spreadProps(__spreadValues({ flexDirection: "row" }, rest), { children }));
}
__name(Row, "Row");
function Column(_a) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx4(IdsFlex, __spreadProps(__spreadValues({ flexDirection: "column" }, rest), { children }));
}
__name(Column, "Column");
var Flex = IdsFlex;
Flex.Row = Row;
Flex.Column = Column;

// src/molecules/Button/ButtonGroup.tsx
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
function ButtonGroup({ children }) {
  return /* @__PURE__ */ jsx5(Flex.Row, { alignItems: "center", css: { gap: spacing.s8 }, children });
}
__name(ButtonGroup, "ButtonGroup");

// src/molecules/Button/utils.ts
var getButtonStylesForVariant = /* @__PURE__ */ __name((variant) => {
  if (variant === "primary") {
    return {
      backgroundColor: "brandPrimaryRegular",
      textColor: "systemGrayscale00",
      hoverTextColor: "systemGrayscale00",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryDark",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemGrayscale00"
    };
  }
  if (variant === "secondary") {
    return {
      borderColor: "systemGrayscale20",
      backgroundColor: "systemGrayscale00",
      textColor: "brandPrimaryRegular",
      hoverTextColor: "brandPrimaryDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryExtraLight",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryLight",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "brandPrimaryExtraDark"
    };
  }
  if (variant === "tertiary") {
    return {
      backgroundColor: "systemGrayscale00",
      textColor: "brandPrimaryRegular",
      hoverTextColor: "brandPrimaryDark",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "brandPrimaryExtraLight",
      focusColor: "systemGrayscale80",
      activeColor: "brandPrimaryLight",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "brandPrimaryExtraDark"
    };
  }
  if (variant === "detrimental") {
    return {
      backgroundColor: "systemDetrimentalRegular",
      textColor: "systemGrayscale00",
      hoverTextColor: "systemGrayscale00",
      disabledTextColor: "systemGrayscale30",
      hoverColor: "systemDetrimentalDark",
      focusColor: "systemGrayscale80",
      activeColor: "systemDetrimentalExtraDark",
      disabledColor: "systemGrayscale10",
      dotLoaderColor: "systemGrayscale00"
    };
  }
  return {
    backgroundColor: null,
    textColor: "systemGrayscale80",
    hoverTextColor: "systemGrayscale80",
    disabledTextColor: "systemGrayscale30",
    dotLoaderColor: "brandPrimaryExtraDark",
    hoverColor: "systemGrayscale10",
    focusColor: "systemGrayscale80",
    activeColor: "systemGrayscale20",
    disabledColor: "systemGrayscale30"
  };
}, "getButtonStylesForVariant");

// src/molecules/Button/Button.tsx
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx6 } from "@emotion/react/jsx-runtime";
var Button2 = forwardRef2((props, ref) => {
  const _a = props, { variant = "primary" } = _a, rest = __objRest(_a, ["variant"]);
  const styles3 = getButtonStylesForVariant(variant);
  return /* @__PURE__ */ jsx6(ButtonBase, __spreadValues({ ref, styles: styles3 }, rest));
});
Button2.Group = ButtonGroup;
Button2.displayName = "Button";

// src/molecules/Button/IconButton.tsx
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var IconButton = forwardRef3(
  /* @__PURE__ */ __name(function IconButton2(props, ref) {
    const _a = props, { compact, variant = "primary", icon: Icon, disabled, size } = _a, rest = __objRest(_a, ["compact", "variant", "icon", "disabled", "size"]);
    const theme = useTheme();
    const iconButtonStyles = __spreadProps(__spreadValues({}, getButtonStylesForVariant(variant)), {
      padding: compact ? "4px" : "10px",
      loadingDotSize: compact ? 4 : 6,
      loadingDotGap: 2,
      minWidth: "20px",
      minHeight: "20px",
      width: "auto"
    });
    const iconSize = size != null ? size : compact ? 16 : 20;
    return /* @__PURE__ */ jsx7(
      ButtonBase,
      __spreadProps(__spreadValues({
        ref,
        styles: iconButtonStyles,
        compact,
        disabled
      }, rest), {
        children: /* @__PURE__ */ jsx7(
          Icon,
          {
            size: iconSize,
            fill: rest.color ? rest.color : disabled ? theme.colors.systemGrayscale30 : theme.colors[iconButtonStyles.textColor]
          }
        )
      })
    );
  }, "IconButton")
);

// src/molecules/CloseButton/CloseButton.tsx
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var CloseButton = forwardRef4((props, ref) => {
  const _a = props, { variant = "unstyled" } = _a, rest = __objRest(_a, ["variant"]);
  return /* @__PURE__ */ jsx8(IconButton, __spreadValues({ ref, icon: CloseIcon, variant }, rest));
});

// src/molecules/Alert/Alert.tsx
import { jsx as jsx9, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var Alert = forwardRef5((props, ref) => {
  const _a = props, {
    layout = "horizontal",
    variant = "info",
    buttons,
    children,
    isDismissible = false,
    onDismiss,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "layout",
    "variant",
    "buttons",
    "children",
    "isDismissible",
    "onDismiss",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const [visible, setVisible] = useState(true);
  const handleDismiss = /* @__PURE__ */ __name(() => {
    setVisible(false);
    onDismiss == null ? void 0 : onDismiss();
  }, "handleDismiss");
  const theme = useTheme();
  if (!visible) {
    return null;
  }
  const alertContainerStyles = {
    padding: "16px",
    borderRadius: "4px",
    gap: "16px",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    backgroundColor: "systemGrayscale00"
  };
  const bodyContainerStyles = __spreadValues({
    display: "flex",
    flexDirection: layout === "stacked" ? "column" : "row",
    flex: 1,
    justifyContent: "space-between",
    alignSelf: "center",
    alignItems: layout === "stacked" ? "flex-start" : "center",
    gap: "8px"
  }, typography.bodyRegular);
  const buttonsContainerStyles = {
    display: "flex",
    gap: "16px",
    alignItems: "end"
  };
  switch (variant) {
    case "info":
      alertContainerStyles.backgroundColor = theme.colors.systemInfoLight;
      break;
    case "success":
      alertContainerStyles.backgroundColor = theme.colors.systemSuccessLight;
      break;
    case "warning":
      alertContainerStyles.backgroundColor = theme.colors.systemAlertLight;
      break;
    case "error":
      alertContainerStyles.backgroundColor = theme.colors.systemDetrimentalLight;
      break;
  }
  const iconProps = {
    size: 24
  };
  let icon = /* @__PURE__ */ jsx9(InformationIcon, __spreadProps(__spreadValues({}, iconProps), { "data-testid": "information-icon" }));
  switch (variant) {
    case "success":
      icon = /* @__PURE__ */ jsx9(
        ApprovedIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemSuccessDark,
          "data-testid": "approved-icon"
        })
      );
      break;
    case "warning":
      icon = /* @__PURE__ */ jsx9(
        NotificationIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemAlertRegular,
          "data-testid": "notification-icon"
        })
      );
      break;
    case "error":
      icon = /* @__PURE__ */ jsx9(
        IssueIcon,
        __spreadProps(__spreadValues({}, iconProps), {
          fill: theme.colors.systemDetrimentalDark,
          "data-testid": "issue-icon"
        })
      );
      break;
  }
  return /* @__PURE__ */ jsxs3("div", __spreadProps(__spreadValues({ css: alertContainerStyles, role: "alert", ref }, rest), { children: [
    icon,
    /* @__PURE__ */ jsxs3("div", { css: bodyContainerStyles, children: [
      children,
      buttons && /* @__PURE__ */ jsx9("div", { css: buttonsContainerStyles, children: buttons })
    ] }),
    isDismissible && /* @__PURE__ */ jsx9(CloseButton, { onClick: handleDismiss, compact: true, variant: "secondary" })
  ] }));
});

// src/molecules/LinkBase/LinkBase.tsx
import { Button as Button3 } from "@mantine/core";
import { jsx as jsx10 } from "@emotion/react/jsx-runtime";
function LinkBase(props) {
  const theme = useTheme();
  const _a = props, {
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    disabled,
    onClick,
    href,
    styles: styles3,
    onChange,
    hideUnderline,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "leftIcon",
    "rightIcon",
    "disabled",
    "onClick",
    "href",
    "styles",
    "onChange",
    "hideUnderline",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const { textColor, activeColor, disabledColor, focusColor, hoverColor } = styles3;
  return /* @__PURE__ */ jsx10(
    Button3,
    __spreadValues({
      component: "a",
      leftSection: LeftIcon && /* @__PURE__ */ jsx10(
        LeftIcon,
        {
          size: 16,
          fill: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }
      ),
      rightSection: RightIcon && /* @__PURE__ */ jsx10(
        RightIcon,
        {
          size: 16,
          fill: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }
      ),
      styles: {
        root: {
          display: "inline-flex"
        },
        section: {
          display: "inline-flex",
          alignItems: "center"
        },
        inner: {
          display: "inline-flex",
          columnGap: "4px"
        }
      },
      css: __spreadProps(__spreadValues({
        cursor: "pointer",
        color: theme.colors[textColor],
        "&:hover": {
          color: theme.colors[hoverColor]
        },
        "&:active": {
          color: theme.colors[activeColor]
        },
        ":focus-visible": {
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "2px"
        }
      }, typography.bodyLink), {
        textDecoration: hideUnderline ? "none" : "underline",
        border: "none",
        borderRadius: "2px"
      }),
      style: __spreadValues({}, disabled && {
        color: theme.colors[disabledColor],
        cursor: "not-allowed"
      }),
      onClick: disabled ? void 0 : onClick,
      href: disabled ? void 0 : href,
      unstyled: true
    }, rest)
  );
}
__name(LinkBase, "LinkBase");

// src/molecules/Link/Link.tsx
import { jsx as jsx11 } from "@emotion/react/jsx-runtime";
var styles = {
  textColor: "brandPrimaryRegular",
  activeColor: "brandPrimaryExtraDark",
  hoverColor: "brandPrimaryDark",
  focusColor: "systemGrayscale80",
  disabledColor: "systemGrayscale30"
};
function Link(props) {
  return /* @__PURE__ */ jsx11(LinkBase, __spreadValues({ styles }, props));
}
__name(Link, "Link");

// src/molecules/DatePicker/SingleDatePicker.tsx
import { useMemo as useMemo4, useEffect, useCallback as useCallback2, useState as useState2 } from "react";

// src/molecules/DatePickerBase/DatePickerBaseInput.tsx
import { useCallback } from "react";
import { Popover, Input } from "@mantine/core";

// src/molecules/DatePickerBase/utils/useSharedDatePickerConfig.ts
import { useMemo as useMemo2 } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DateIcon
} from "@instacart/ids-core";

// src/molecules/DatePickerBase/DatePickerDayIndicator.tsx
import { Indicator } from "@mantine/core";
import { jsx as jsx12 } from "@emotion/react/jsx-runtime";
function createCurrentDateIndicator(currentDate) {
  return (date) => {
    const theme = useTheme();
    const day = date.getDate();
    const disabled = date.getDate() !== currentDate.getDate() || date.getMonth() !== currentDate.getMonth() || date.getFullYear() !== currentDate.getFullYear();
    return /* @__PURE__ */ jsx12(
      Indicator,
      {
        "data-testid": "date-picker-day-indicator",
        size: 6,
        color: theme.colors.systemDetrimentalRegular,
        disabled,
        "data-disabled": disabled,
        offset: 0,
        style: { "--indicator-top": "-2px", "--indicator-right": "-4px" },
        children: /* @__PURE__ */ jsx12("div", { children: day })
      }
    );
  };
}
__name(createCurrentDateIndicator, "createCurrentDateIndicator");

// src/molecules/DatePickerBase/utils/useSharedDatePickerConfig.ts
var useSharedCalendarConfig = /* @__PURE__ */ __name((showDayIndicator) => {
  const currentDate = useMemo2(() => /* @__PURE__ */ new Date(), []);
  const CurrentDateIndicator = useMemo2(() => createCurrentDateIndicator(currentDate), [currentDate]);
  const sharedStyles = useMemo2(() => {
    return {
      calendarLeftIcon: ChevronLeftIcon,
      calendarRightIcon: ChevronRightIcon,
      calendarRenderDay: showDayIndicator ? CurrentDateIndicator : void 0
    };
  }, [showDayIndicator, CurrentDateIndicator]);
  return sharedStyles;
}, "useSharedCalendarConfig");
var useSharedInputConfig = /* @__PURE__ */ __name(({
  width,
  maxWidth,
  compact,
  disabled,
  isCalendarOpen,
  readOnly
}) => {
  const theme = useTheme();
  const textColor = disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80;
  const sharedStyles = useMemo2(() => {
    return {
      inputLeftIcon: DateIcon({
        size: 16,
        fill: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
      }),
      inputRightIcon: readOnly ? void 0 : isCalendarOpen ? ChevronUpIcon({
        size: 16,
        css: { cursor: disabled ? "not-allowed" : "pointer", fill: textColor }
      }) : ChevronDownIcon({
        size: 16,
        css: { cursor: disabled ? "not-allowed" : "pointer", fill: textColor }
      }),
      css: {
        width,
        maxWidth,
        "& button": __spreadValues({
          cursor: readOnly ? "unset" : "pointer",
          minHeight: "unset",
          height: compact ? "30px" : "40px",
          padding: compact ? "2px 34px" : "4px 34px",
          border: `1px solid ${isCalendarOpen ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale30}`,
          borderRadius: compact ? radius.interactiveCompact : radius.interactive,
          color: textColor
        }, typography.bodyRegular),
        '& button[data-error="true"]': {
          backgroundColor: theme.colors.systemDetrimentalLight,
          borderColor: theme.colors.systemDetrimentalRegular
        },
        "& button:disabled": {
          backgroundColor: theme.colors.systemGrayscale10,
          color: theme.colors.systemGrayscale30
        },
        '& button:focus-visible:not([data-error="true"])': {
          borderColor: theme.colors.brandPrimaryRegular,
          outline: `2px solid ${theme.colors.systemGrayscale80}`,
          outlineOffset: "2px"
        },
        '& button[data-readonly="true"]': {
          backgroundColor: "transparent",
          borderColor: "transparent"
        },
        ':hover button:not(:disabled):not([data-error="true"]):not([data-readonly="true"])': __spreadProps(__spreadValues({}, typography.bodyEmphasized), {
          color: textColor,
          borderColor: theme.colors.systemGrayscale60
        })
      }
    };
  }, [disabled, theme, isCalendarOpen, textColor, width, maxWidth, compact, readOnly]);
  return sharedStyles;
}, "useSharedInputConfig");

// src/molecules/DatePickerBase/DatePickerBaseInput.tsx
import { jsx as jsx13, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
function DatePickerBaseInput(props) {
  const theme = useTheme();
  const _a = props, {
    disabled,
    compact,
    styles: styles3,
    label,
    error,
    readOnly,
    formattedValue,
    children,
    isCalendarOpen,
    setIsCalendarOpen,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "styles",
    "label",
    "error",
    "readOnly",
    "formattedValue",
    "children",
    "isCalendarOpen",
    "setIsCalendarOpen",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const { width, maxWidth } = styles3;
  const {
    css: inputCSS,
    inputLeftIcon,
    inputRightIcon
  } = useSharedInputConfig({
    width,
    maxWidth,
    compact,
    disabled,
    isCalendarOpen,
    readOnly
  });
  const updateIsCalendarOpen = useCallback(
    (isOpen) => {
      if (!disabled && !readOnly) {
        setIsCalendarOpen(isOpen);
      } else if (!isOpen) {
        setIsCalendarOpen(false);
      }
    },
    [disabled, readOnly, setIsCalendarOpen]
  );
  return /* @__PURE__ */ jsx13(
    Input.Wrapper,
    {
      styles: {
        root: {
          width
        },
        label: __spreadValues({}, typography.bodyEmphasized),
        error: { color: theme.colors.systemDetrimentalRegular }
      },
      label,
      error,
      children: /* @__PURE__ */ jsxs4(
        Popover,
        {
          position: "bottom-start",
          trapFocus: false,
          opened: isCalendarOpen,
          onOpen: () => updateIsCalendarOpen(true),
          onClose: () => updateIsCalendarOpen(false),
          closeOnClickOutside: true,
          closeOnEscape: true,
          styles: {
            dropdown: __spreadValues({
              borderRadius: radius.interactive
            }, elevation.high.shadow)
          },
          children: [
            /* @__PURE__ */ jsx13(Popover.Target, { children: /* @__PURE__ */ jsx13(
              Input,
              __spreadProps(__spreadValues({
                css: inputCSS,
                type: "button",
                component: "button",
                leftSection: inputLeftIcon,
                rightSection: inputRightIcon,
                leftSectionPointerEvents: "none",
                rightSectionPointerEvents: "none",
                disabled,
                "data-readonly": readOnly,
                "data-error": Boolean(error),
                onClick: () => updateIsCalendarOpen(!isCalendarOpen)
              }, rest), {
                children: formattedValue
              })
            ) }),
            /* @__PURE__ */ jsx13(Popover.Dropdown, { children })
          ]
        }
      )
    }
  );
}
__name(DatePickerBaseInput, "DatePickerBaseInput");

// src/molecules/DatePickerBase/DatePickerCalendar.tsx
import { useMemo as useMemo3 } from "react";
import {
  DatePicker as MantineDatePicker
} from "@mantine/dates";
import { ClassNames } from "@emotion/react";
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
var getSharedButtonStyles = /* @__PURE__ */ __name((theme) => {
  const calendarButtonStyles = getButtonStylesForVariant("tertiary");
  return {
    backgroundColor: theme.colors[calendarButtonStyles.backgroundColor],
    color: theme.colors[calendarButtonStyles.textColor],
    ":focus-visible": {
      backgroundColor: theme.colors[calendarButtonStyles.hoverColor],
      outline: `2px solid ${theme.colors[calendarButtonStyles.focusColor]}`,
      outlineOffset: "2px"
    },
    ":hover": {
      backgroundColor: `${theme.colors[calendarButtonStyles.hoverColor]} !important`,
      color: `${theme.colors[calendarButtonStyles.hoverTextColor]} !important`
    },
    ":active": {
      backgroundColor: `${theme.colors[calendarButtonStyles.activeColor]} !important`
    }
  };
}, "getSharedButtonStyles");
function DatePickerCalendar(props) {
  const theme = useTheme();
  const _a = props, { showDayIndicator, defaultValue, defaultDate } = _a, rest = __objRest(_a, ["showDayIndicator", "defaultValue", "defaultDate"]);
  const {
    calendarRightIcon: CalendarNextIcon,
    calendarLeftIcon: CalendarPreviousIcon,
    calendarRenderDay
  } = useSharedCalendarConfig(showDayIndicator);
  const sharedButtonStyles = useMemo3(() => getSharedButtonStyles(theme), [theme]);
  return /* @__PURE__ */ jsx14(ClassNames, { children: ({ css: css2 }) => /* @__PURE__ */ jsx14(
    MantineDatePicker,
    __spreadValues({
      classNames: {
        calendarHeader: css2(__spreadProps(__spreadValues({
          display: "flex",
          columnGap: spacing.s8
        }, typography.subtitle), {
          marginBottom: spacing.s16,
          width: "100%",
          maxWidth: "unset"
        })),
        calendarHeaderLevel: css2(__spreadValues(__spreadValues({}, typography.subtitle), sharedButtonStyles)),
        calendarHeaderControl: css2(__spreadValues({}, sharedButtonStyles)),
        month: css2({
          width: "auto"
        }),
        monthCell: css2({
          border: `1px solid ${theme.colors.systemGrayscale20}`,
          "&[data-with-spacing]": {
            padding: 0
          },
          height: "auto"
        }),
        yearsListControl: css2(__spreadValues(__spreadValues({}, typography.bodyEmphasized), sharedButtonStyles)),
        monthsListControl: css2(__spreadValues(__spreadValues({}, typography.bodyEmphasized), sharedButtonStyles)),
        day: css2(__spreadProps(__spreadValues({}, typography.accentEmphasized), {
          color: theme.colors.systemGrayscale80,
          borderRadius: 0,
          height: 39,
          width: 39,
          "&:not([disabled]):not([data-selected])": {
            "&:hover": {
              color: `${theme.colors.systemGrayscale80} !important`,
              backgroundColor: `${theme.colors.brandPrimaryExtraLight} !important`
            },
            "&:active": {
              color: `${theme.colors.systemGrayscale00} !important`,
              backgroundColor: `${theme.colors.brandPrimaryDark} !important`
            }
          },
          "&[data-selected]": {
            backgroundColor: `${theme.colors.brandPrimaryRegular} !important`,
            color: `${theme.colors.systemGrayscale00} !important`,
            "&:hover": {
              backgroundColor: `${theme.colors.brandPrimaryDark} !important`,
              color: `${theme.colors.systemGrayscale00} !important`
            }
          },
          "&[disabled]": {
            pointerEvents: "none"
          },
          "&[data-in-range]": {
            backgroundColor: `${theme.colors.brandPrimaryLight} !important`
          },
          "&[data-in-range]:hover:not([data-selected])": {
            backgroundColor: `${theme.colors.brandPrimaryLight} !important`
          },
          ":focus-visible": {
            outline: `2px solid ${theme.colors.systemGrayscale80}`,
            outlineOffset: "-1px"
          }
        })),
        weekday: css2(__spreadValues({
          color: theme.colors.systemGrayscale60
        }, typography.accentRegular)),
        levelsGroup: css2({
          gap: spacing.s24
        })
      },
      nextIcon: /* @__PURE__ */ jsx14(CalendarNextIcon, { size: 24, fill: "currentColor" }),
      renderDay: calendarRenderDay,
      previousIcon: /* @__PURE__ */ jsx14(CalendarPreviousIcon, { size: 24, fill: "currentColor" }),
      hideOutsideDates: true
    }, rest)
  ) });
}
__name(DatePickerCalendar, "DatePickerCalendar");

// src/molecules/DatePickerBase/utils/dateFormatUtils.ts
var import_dayjs = __toESM(require_dayjs_min());
var DATE_FORMAT = "MMM D, YYYY";
var formatSingleDate = /* @__PURE__ */ __name((date) => {
  if (!date) {
    return "";
  }
  const parsedDate = (0, import_dayjs.default)(date);
  if (!parsedDate.isValid()) {
    return "";
  }
  return parsedDate.format(DATE_FORMAT);
}, "formatSingleDate");

// src/molecules/DatePicker/SingleDatePicker.tsx
import { jsx as jsx15 } from "@emotion/react/jsx-runtime";
function SingleDatePicker(props) {
  const _a = props, {
    value,
    onChange,
    label,
    error,
    compact,
    readOnly,
    disabled,
    calendarProps,
    showDayIndicator = true,
    closeOnChange = true
  } = _a, rest = __objRest(_a, [
    "value",
    "onChange",
    "label",
    "error",
    "compact",
    "readOnly",
    "disabled",
    "calendarProps",
    "showDayIndicator",
    "closeOnChange"
  ]);
  const [focusedDate, setFocusedDate] = useState2(() => /* @__PURE__ */ new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState2(false);
  useEffect(() => {
    if (value) {
      setFocusedDate(value);
    }
  }, [value]);
  const { formattedValue } = useMemo4(
    () => ({
      formattedValue: formatSingleDate(value)
    }),
    [value]
  );
  const onChangeHandler = useCallback2(
    (newDate) => {
      onChange == null ? void 0 : onChange(newDate);
      if (closeOnChange) {
        setIsCalendarOpen(false);
      }
    },
    [onChange, closeOnChange]
  );
  return /* @__PURE__ */ jsx15(
    DatePickerBaseInput,
    __spreadProps(__spreadValues({
      "data-testid": "single-date-picker-input",
      label,
      error,
      compact,
      readOnly,
      disabled,
      isCalendarOpen,
      formattedValue,
      setIsCalendarOpen,
      styles: { width: "100%", maxWidth: "200px" }
    }, rest), {
      children: /* @__PURE__ */ jsx15(
        DatePickerCalendar,
        __spreadValues({
          "data-testid": "single-date-picker-calendar",
          type: "default",
          hideOutsideDates: true,
          value,
          date: focusedDate,
          onChange: onChangeHandler,
          onDateChange: setFocusedDate,
          showDayIndicator
        }, calendarProps)
      )
    })
  );
}
__name(SingleDatePicker, "SingleDatePicker");

// src/molecules/MarkerBase/MarkerBase.tsx
import { jsx as jsx16 } from "@emotion/react/jsx-runtime";
var TEXT_COLOR = "systemGrayscale80";
function MarkerBase({ text, styles: styles3 }) {
  const { backgroundColor } = styles3;
  const theme = useTheme();
  return /* @__PURE__ */ jsx16(
    "span",
    {
      css: __spreadValues({
        display: "inline-block",
        padding: `1px ${spacing.s4}`,
        backgroundColor: theme.colors[backgroundColor],
        color: theme.colors[TEXT_COLOR]
      }, typography.accentRegular),
      children: text
    }
  );
}
__name(MarkerBase, "MarkerBase");

// src/molecules/Marker/Marker.tsx
import { jsx as jsx17 } from "@emotion/react/jsx-runtime";
var getStylesForVariant = /* @__PURE__ */ __name((variant) => {
  if (variant === "neutral") {
    return { backgroundColor: "systemGrayscale10" };
  }
  if (variant === "success") {
    return { backgroundColor: "systemSuccessLight" };
  }
  if (variant === "detrimental") {
    return { backgroundColor: "systemDetrimentalLight" };
  }
  return { backgroundColor: "systemAlertLight" };
}, "getStylesForVariant");
function Marker({ text, variant }) {
  const styles3 = getStylesForVariant(variant);
  return /* @__PURE__ */ jsx17(MarkerBase, { text, styles: styles3 });
}
__name(Marker, "Marker");

// src/molecules/TooltipBase/TooltipBase.tsx
import { forwardRef as forwardRef6 } from "react";
import { Tooltip as MantineTooltip } from "@mantine/core";
import { jsx as jsx18 } from "@emotion/react/jsx-runtime";
var TooltipPosition = {
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  topEnd: "top-end",
  topStart: "top-start",
  bottomEnd: "bottom-end",
  bottomStart: "bottom-start",
  leftEnd: "left-end",
  leftStart: "left-start",
  rightEnd: "right-end",
  rightStart: "right-start"
};
var ToolTipContent = forwardRef6((props, ref) => /* @__PURE__ */ jsx18("div", { css: { display: "flex" }, ref, children: props.children }));
function TooltipBase(props) {
  const theme = useTheme();
  const { position = "top", children, label, styles: styles3 } = props;
  const { color, backgroundColor, arrowSize, arrowOffset } = styles3;
  return /* @__PURE__ */ jsx18(
    MantineTooltip,
    {
      styles: {
        arrow: {
          backgroundColor: theme.colors[backgroundColor]
        }
      },
      css: __spreadValues({
        color: theme.colors[color],
        backgroundColor: theme.colors[backgroundColor],
        position: "absolute",
        padding: "8px 12px",
        boxShadow: elevation.high.shadow.boxShadow
      }, typography.bodyRegular),
      position: TooltipPosition[position],
      arrowSize,
      arrowOffset,
      label,
      withArrow: true,
      unstyled: true,
      children: /* @__PURE__ */ jsx18(ToolTipContent, { children })
    }
  );
}
__name(TooltipBase, "TooltipBase");

// src/molecules/Tooltip/Tooltip.tsx
import { jsx as jsx19 } from "@emotion/react/jsx-runtime";
function Tooltip(props) {
  const styles3 = {
    backgroundColor: "systemInfoLight",
    color: "systemGrayscale80",
    arrowSize: 10,
    arrowOffset: 10
  };
  return /* @__PURE__ */ jsx19(TooltipBase, __spreadValues({ styles: styles3 }, props));
}
__name(Tooltip, "Tooltip");

// src/molecules/ButtonText/ButtonText.tsx
import { forwardRef as forwardRef7 } from "react";
import { jsx as jsx20 } from "@emotion/react/jsx-runtime";
var getActionButtonStyles = /* @__PURE__ */ __name((compact) => __spreadProps(__spreadValues({}, getButtonStylesForVariant("tertiary")), {
  padding: "0px 4px",
  minHeight: "20px",
  minWidth: "auto",
  innerGap: compact ? spacing.s4 : spacing.s8,
  borderRadius: spacing.s4,
  iconSize: 16
}), "getActionButtonStyles");
var ButtonText = forwardRef7((props, ref) => {
  const _a = props, { compact } = _a, rest = __objRest(_a, ["compact"]);
  const styles3 = getActionButtonStyles(compact);
  return /* @__PURE__ */ jsx20(ButtonBase, __spreadValues({ compact, ref, styles: styles3 }, rest));
});
ButtonText.displayName = "ButtonText";

// src/molecules/CheckboxBase/CheckboxBase.tsx
import { useEffect as useEffect2, useState as useState3, useCallback as useCallback3 } from "react";
import { Checkbox as MantineCheckbox } from "@mantine/core";
import {
  CheckboxSelectedIcon,
  CheckboxUnselectedIcon,
  CheckboxIndeterminateIcon
} from "@instacart/ids-core";
import { jsx as jsx21 } from "@emotion/react/jsx-runtime";
var getLabelTypography = /* @__PURE__ */ __name((checked, compact) => {
  if (compact) {
    return typography.accentEmphasized;
  }
  return checked ? typography.bodyEmphasized : typography.bodyRegular;
}, "getLabelTypography");
function CheckboxBase(props) {
  const theme = useTheme();
  const _a = props, {
    checked,
    indeterminate,
    disabled,
    onChange,
    styles: styles3,
    label,
    description,
    compact,
    className: className,
    style
  } = _a, rest = __objRest(_a, [
    "checked",
    "indeterminate",
    "disabled",
    "onChange",
    "styles",
    "label",
    "description",
    "compact",
    /** The below props are omitted to prevent custom restyling */
    "className",
    "style"
  ]);
  const { textColor, disabledColor, checkboxBorderColor, checkboxIconColor, focusColor } = styles3;
  const [internalChecked, setInternalChecked] = useState3(checked != null ? checked : false);
  const displayChecked = indeterminate || internalChecked;
  const labelTypography = getLabelTypography(displayChecked, compact);
  const checkboxSize = compact ? 16 : 20;
  useEffect2(() => {
    setInternalChecked(checked);
  }, [checked]);
  const defaultOnChange2 = useCallback3(
    (evt) => {
      if (checked === void 0) {
        setInternalChecked(evt.currentTarget.checked);
      }
    },
    [setInternalChecked, checked]
  );
  const onChangeHandler = onChange || defaultOnChange2;
  const Icon = indeterminate ? CheckboxIndeterminateIcon : internalChecked ? CheckboxSelectedIcon : CheckboxUnselectedIcon;
  return /* @__PURE__ */ jsx21(
    MantineCheckbox,
    __spreadValues({
      styles: {
        body: {
          display: "flex"
        },
        label: __spreadValues({
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, labelTypography),
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "4px"
        },
        description: __spreadValues({
          margin: "0px",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, typography.accentRegular),
        input: {
          margin: 0,
          width: `${checkboxSize}px`,
          height: `${checkboxSize}px`,
          appearance: "none",
          cursor: disabled ? "not-allowed" : "pointer"
        },
        inner: {
          display: "flex",
          position: "relative"
        }
      },
      css: {
        // Mantine does not allow styling input focus styles directly through Styles API
        // so we apply the CSS via emotion
        "& input:focus": {
          outline: "none"
        },
        "& input:focus-visible": {
          outline: `2px solid ${theme.colors[focusColor]}`,
          outlineOffset: "1px",
          borderRadius: "2px"
        }
      },
      onChange: disabled ? void 0 : onChangeHandler,
      icon: () => /* @__PURE__ */ jsx21(
        Icon,
        {
          size: checkboxSize,
          css: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            padding: compact ? "1px 0" : "0"
          },
          fill: disabled ? theme.colors[disabledColor] : displayChecked ? theme.colors[checkboxIconColor] : theme.colors[checkboxBorderColor]
        }
      ),
      indeterminate,
      checked,
      disabled,
      label,
      description,
      unstyled: true
    }, rest)
  );
}
__name(CheckboxBase, "CheckboxBase");

// src/molecules/InputGroupLayout/InputGroupLayout.tsx
import { jsx as jsx22, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
function InputGroupLayout(props) {
  const { label, direction = "row", children, styles: styles3 } = props;
  const { rowGap = 24, columnGap = 16, maxWidth = 628, itemsPerRow = 4 } = styles3 != null ? styles3 : {};
  const isRowLayout = direction === "row";
  const itemWidth = 100 / (itemsPerRow != null ? itemsPerRow : 4);
  const containerCSS = {
    flexWrap: "wrap",
    maxWidth,
    rowGap,
    /**
     * Set each item to take an equal height/width, accounting for gaps
     * See https://go/checkboxLayout for reference
     */
    "& > *": __spreadValues({}, isRowLayout && { width: `calc(${itemWidth}% - ${columnGap}px)`, flexGrow: 1 })
  };
  return /* @__PURE__ */ jsxs5(
    Flex.Column,
    {
      css: {
        flexGrow: 1,
        rowGap: "8px"
      },
      children: [
        label,
        /* @__PURE__ */ jsx22(
          Flex,
          {
            "data-test-id": "input-group-layout-container",
            flexDirection: direction,
            css: containerCSS,
            children
          }
        )
      ]
    }
  );
}
__name(InputGroupLayout, "InputGroupLayout");

// src/molecules/Checkbox/CheckboxLayout.tsx
import { jsx as jsx23 } from "@emotion/react/jsx-runtime";
function CheckboxLayout(props) {
  const { label: Label, children, direction: flexDirection = "column" } = props;
  return /* @__PURE__ */ jsx23(InputGroupLayout, { label: Label, direction: flexDirection, children });
}
__name(CheckboxLayout, "CheckboxLayout");

// src/molecules/Checkbox/Checkbox.tsx
import { jsx as jsx24 } from "@emotion/react/jsx-runtime";
var styles2 = {
  textColor: "systemGrayscale80",
  disabledColor: "systemGrayscale30",
  checkboxBorderColor: "systemGrayscale60",
  checkboxIconColor: "systemGrayscale80",
  focusColor: "systemGrayscale80"
};
function Checkbox(props) {
  return /* @__PURE__ */ jsx24(CheckboxBase, __spreadProps(__spreadValues({}, props), { styles: styles2 }));
}
__name(Checkbox, "Checkbox");
Checkbox.Layout = CheckboxLayout;

// src/molecules/MenuBase/MenuBase.tsx
import { useTheme as useTheme2 } from "@instacart/ids-core";
import { Menu } from "@mantine/core";
import { jsx as jsx25, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
var MenuPosition = {
  bottomEnd: "bottom-end",
  bottomStart: "bottom-start"
};
function MenuBase(props) {
  const { target, children, position = "bottomStart", onMenuStateChange } = props;
  const theme = useTheme2();
  return /* @__PURE__ */ jsxs6(
    Menu,
    {
      position: MenuPosition[position],
      onChange: onMenuStateChange,
      offset: 4,
      styles: {
        dropdown: {
          boxShadow: elevation.high.shadow.boxShadow,
          border: "none",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          padding: "8px 0px",
          backgroundColor: theme.colors.systemGrayscale00
        }
      },
      children: [
        /* @__PURE__ */ jsx25(Menu.Target, { children: target }),
        /* @__PURE__ */ jsx25(Menu.Dropdown, { children })
      ]
    }
  );
}
__name(MenuBase, "MenuBase");

// src/molecules/MenuBase/ButtonMenu.tsx
import { ChevronDownIcon as ChevronDownIcon2, ChevronUpIcon as ChevronUpIcon2 } from "@instacart/ids-core";
import { useState as useState4 } from "react";
import { jsx as jsx26 } from "@emotion/react/jsx-runtime";
function ButtonMenu(props) {
  const _a = props, { position, buttonText, children } = _a, buttonProps = __objRest(_a, ["position", "buttonText", "children"]);
  const [isOpen, setIsOpen] = useState4(false);
  return /* @__PURE__ */ jsx26(
    MenuBase,
    {
      position,
      onMenuStateChange: (newIsOpen) => setIsOpen(newIsOpen),
      target: /* @__PURE__ */ jsx26(Button2, __spreadProps(__spreadValues({}, buttonProps), { rightIcon: isOpen ? ChevronUpIcon2 : ChevronDownIcon2, children: buttonText })),
      children
    }
  );
}
__name(ButtonMenu, "ButtonMenu");

// src/molecules/MenuBase/IconButtonMenu.tsx
import { jsx as jsx27 } from "@emotion/react/jsx-runtime";
function IconButtonMenu(props) {
  const _a = props, { children } = _a, buttonProps = __objRest(_a, ["children"]);
  return /* @__PURE__ */ jsx27(MenuBase, { target: /* @__PURE__ */ jsx27(IconButton, __spreadProps(__spreadValues({}, buttonProps), { "data-testid": "icon-button-menu-target" })), children });
}
__name(IconButtonMenu, "IconButtonMenu");

// src/molecules/MenuItem/MenuItem.tsx
import { forwardRef as forwardRef8 } from "react";
import { useTheme as useTheme3 } from "@instacart/ids-core";
import { Menu as Menu2 } from "@mantine/core";
import { css } from "@emotion/react";
import { jsx as jsx28, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
var MenuItem = forwardRef8(/* @__PURE__ */ __name(function MenuItem2(props, ref) {
  const _a = props, { leftIcon: LeftIcon, compact, disabled, title, text } = _a, rest = __objRest(_a, ["leftIcon", "compact", "disabled", "title", "text"]);
  const theme = useTheme3();
  const headerTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  const textTypography = compact ? typography.accentRegular : typography.bodyRegular;
  const bodyCss = css({
    boxSizing: "border-box",
    backgroundColor: theme.colors.systemGrayscale00,
    color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
    padding: compact ? "6px 16px" : "10px 16px",
    cursor: disabled ? "not-allowed" : "pointer",
    border: 0,
    pointerEvents: "auto",
    minWidth: 300,
    "&:hover": {
      backgroundColor: theme.colors.brandPrimaryLight
    },
    ":focus-visible": {
      backgroundColor: theme.colors.brandPrimaryLight,
      outline: `2px solid ${theme.colors.brandPrimaryDark}`,
      outlineOffset: "2px",
      zIndex: 1
    }
  });
  return /* @__PURE__ */ jsx28(Menu2.Item, __spreadProps(__spreadValues({ css: __spreadValues({}, bodyCss), disabled }, rest), { ref, children: /* @__PURE__ */ jsxs7(
    "div",
    {
      css: {
        display: "flex",
        flexDirection: "row",
        gap: 8
      },
      children: [
        LeftIcon && /* @__PURE__ */ jsx28("div", { css: { flexShrink: 0 }, children: /* @__PURE__ */ jsx28(
          LeftIcon,
          {
            css: { position: "relative", top: 2 },
            size: 16,
            fill: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80,
            "data-testid": "menu-item-left-icon"
          }
        ) }),
        /* @__PURE__ */ jsxs7(
          "div",
          {
            css: {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              flexGrow: 1
            },
            children: [
              /* @__PURE__ */ jsx28("div", { css: __spreadProps(__spreadValues({}, headerTypography), { wordBreak: "break-word", textAlign: "left" }), children: title }),
              /* @__PURE__ */ jsx28("div", { css: __spreadProps(__spreadValues({}, textTypography), { wordBreak: "break-word", textAlign: "left" }), children: text })
            ]
          }
        )
      ]
    }
  ) }));
}, "MenuItem"));

// src/molecules/MenuHeader/MenuHeader.tsx
import { useTheme as useTheme4 } from "@instacart/ids-core";
import { jsx as jsx29, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
function MenuHeader(props) {
  const { leftIcon: LeftIcon, compact, title } = props;
  const theme = useTheme4();
  const headerTypography = compact ? typography.accentEmphasized : typography.bodyEmphasized;
  return /* @__PURE__ */ jsx29(
    "div",
    {
      css: {
        boxSizing: "border-box",
        backgroundColor: theme.colors.systemGrayscale00,
        color: theme.colors.systemGrayscale80,
        padding: compact ? "6px 16px" : "10px 16px",
        cursor: "auto",
        border: 0,
        minWidth: 300
      },
      children: /* @__PURE__ */ jsxs8(
        "div",
        {
          css: {
            display: "flex",
            flexDirection: "row",
            gap: 8
          },
          children: [
            LeftIcon && /* @__PURE__ */ jsx29("div", { css: { flexShrink: 0 }, children: /* @__PURE__ */ jsx29(
              LeftIcon,
              {
                css: { position: "relative", top: 2 },
                size: 16,
                fill: theme.colors.systemGrayscale80,
                "data-testid": "menu-header-left-icon"
              }
            ) }),
            /* @__PURE__ */ jsx29(
              "div",
              {
                css: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flexGrow: 1
                },
                children: /* @__PURE__ */ jsx29("div", { css: __spreadProps(__spreadValues({}, headerTypography), { wordBreak: "break-word", textAlign: "left" }), children: title })
              }
            )
          ]
        }
      )
    }
  );
}
__name(MenuHeader, "MenuHeader");

// src/molecules/Pill/Pill.tsx
import { forwardRef as forwardRef9 } from "react";
import { CORE_COLORS } from "@instacart/ids-core";
import { jsx as jsx30, jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
var Pill = forwardRef9((props, ref) => {
  const _a = props, {
    color = "gray",
    icon: Icon,
    disabled,
    onClose,
    className,
    css: css2,
    style,
    children
  } = _a, rest = __objRest(_a, [
    "color",
    "icon",
    "disabled",
    "onClose",
    "className",
    "css",
    "style",
    "children"
  ]);
  const theme = useTheme();
  const pillStyles = __spreadProps(__spreadValues({
    display: "inline-flex",
    alignSelf: "center",
    alignItems: "center",
    minHeight: "20px",
    minWidth: "50px",
    height: "fit-content",
    padding: "1px 1px",
    paddingLeft: "4px",
    paddingRight: onClose ? "1px" : "4px",
    borderRadius: "4px",
    gap: "4px",
    justifyContent: "center"
  }, typography.accentEmphasized), {
    backgroundColor: theme.colors.systemGrayscale00,
    color: theme.colors.systemGrayscale10,
    border: `1px solid ${theme.colors.systemGrayscale20}`
  });
  if (color === "gray") {
    pillStyles.backgroundColor = theme.colors.systemGrayscale10;
    pillStyles.color = theme.colors.systemGrayscale60;
    pillStyles.border = "none";
  } else if (color === "green") {
    pillStyles.backgroundColor = theme.colors.brandPrimaryExtraLight;
    pillStyles.color = CORE_COLORS.kale;
    pillStyles.border = "none";
  }
  if (disabled) {
    pillStyles.backgroundColor = theme.colors.systemGrayscale20;
    pillStyles.color = theme.colors.systemGrayscale30;
  }
  const iconColor = disabled ? "systemGrayscale30" : color === "gray" ? "systemGrayscale80" : "brandKale";
  return /* @__PURE__ */ jsxs9("div", __spreadProps(__spreadValues({ css: pillStyles, ref }, rest), { children: [
    Icon && /* @__PURE__ */ jsx30("span", { css: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsx30(Icon, { size: 16, color: iconColor }) }),
    children,
    onClose && /* @__PURE__ */ jsx30(CloseButton, { size: 8, color: pillStyles.color, compact: true, onClick: onClose })
  ] }));
});
function CategoryPill(props) {
  return /* @__PURE__ */ jsx30(Pill, __spreadValues({ color: "green" }, props));
}
__name(CategoryPill, "CategoryPill");
function SelectionPill(props) {
  return /* @__PURE__ */ jsx30(Pill, __spreadValues({ color: "gray" }, props));
}
__name(SelectionPill, "SelectionPill");

// src/molecules/Pill/PillGroup.tsx
import { CloseIcon as CloseIcon2 } from "@instacart/ids-core";
import { jsx as jsx31, jsxs as jsxs10 } from "@emotion/react/jsx-runtime";
function PillGroup(props) {
  const { children, gap: gap2 = "8px", clearButtonText, onClearAll } = props;
  return /* @__PURE__ */ jsxs10(Flex.Row, { children: [
    /* @__PURE__ */ jsx31(Flex.Row, { gap: gap2, children }),
    onClearAll && /* @__PURE__ */ jsx31(Button2, { rightIcon: CloseIcon2, compact: true, variant: "tertiary", onClick: onClearAll, children: clearButtonText })
  ] });
}
__name(PillGroup, "PillGroup");

// src/molecules/SwitchToggle/SwitchToggle.tsx
import { Switch as MantineSwitchToggle } from "@mantine/core";
import { useEffect as useEffect3, useState as useState5 } from "react";
import { jsx as jsx32 } from "@emotion/react/jsx-runtime";
var trackHeight = 1;
var trackWidth = 1.75;
var trackBorderRadius = 1;
var thumbMargin = 0.1;
var thumbDiameter = trackHeight - thumbMargin * 2;
var thumbMovingDistance = trackWidth - trackHeight;
var switchToggleMeasurements = {
  trackHeight: `${trackHeight}rem`,
  trackWidth: `${trackWidth}rem`,
  trackBorderRadius: `${trackBorderRadius}rem`,
  thumbMargin: `${thumbMargin}rem`,
  thumbDiameter: `${thumbDiameter}rem`,
  thumbMovingDistance: `${thumbMovingDistance}rem`
};
function SwitchToggle(props) {
  const theme = useTheme();
  const _a = props, {
    value,
    initialValue,
    label,
    description,
    disabled,
    css: css2,
    className,
    style,
    onChange
  } = _a, rest = __objRest(_a, [
    "value",
    "initialValue",
    "label",
    "description",
    "disabled",
    "css",
    "className",
    "style",
    "onChange"
  ]);
  const isControlled = value !== void 0;
  const [localChecked, setLocalChecked] = useState5(initialValue != null ? initialValue : false);
  const checked = isControlled ? value : localChecked;
  const onChangeHandler = isControlled ? onChange : () => setLocalChecked((prevChecked) => !prevChecked);
  useEffect3(() => {
    if (isControlled) {
      setLocalChecked(value);
    }
  }, [value, isControlled]);
  const textColor = disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80;
  return /* @__PURE__ */ jsx32(
    MantineSwitchToggle,
    __spreadValues({
      styles: {
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start"
        },
        label: __spreadValues({
          color: textColor
        }, checked ? typography.bodyEmphasized : typography.bodyRegular),
        description: __spreadValues({
          margin: "0",
          color: textColor
        }, typography.accentRegular),
        body: {
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          columnGap: "2.25rem"
        },
        input: {
          opacity: "0",
          width: "0",
          height: "0"
        },
        track: {
          position: "absolute",
          width: switchToggleMeasurements.trackWidth,
          height: switchToggleMeasurements.trackHeight,
          backgroundColor: disabled ? theme.colors.systemGrayscale10 : checked ? theme.colors.systemGrayscale80 : theme.colors.systemGrayscale30,
          borderRadius: switchToggleMeasurements.trackBorderRadius,
          transition: "background-color 0.3s",
          marginLeft: switchToggleMeasurements.thumbMargin,
          marginTop: switchToggleMeasurements.thumbMargin
        },
        thumb: {
          position: "absolute",
          width: switchToggleMeasurements.thumbDiameter,
          height: switchToggleMeasurements.thumbDiameter,
          left: switchToggleMeasurements.thumbMargin,
          bottom: switchToggleMeasurements.thumbMargin,
          backgroundColor: disabled ? theme.colors.systemGrayscale20 : theme.colors.systemGrayscale00,
          borderRadius: radius.round,
          transition: "transform 0.3s",
          transform: checked ? `translateX(${switchToggleMeasurements.thumbMovingDistance})` : "none"
        }
      },
      label,
      description,
      checked,
      onChange: onChangeHandler,
      disabled,
      unstyled: true
    }, rest)
  );
}
__name(SwitchToggle, "SwitchToggle");

// src/molecules/Radio/Radio.tsx
import { Radio as MantineRadio } from "@mantine/core";
import {
  RadioSelectedIcon,
  RadioUnselectedIcon,
  RadioDisabledUnselectedIcon,
  RadioDisabledSelectedIcon
} from "@instacart/ids-core";

// src/molecules/Radio/RadioGroupContext.ts
import { createContext, useContext as useContext2 } from "react";
var RadioGroupContext = createContext(void 0);
var useRadioGroupContext = /* @__PURE__ */ __name(() => {
  return useContext2(RadioGroupContext);
}, "useRadioGroupContext");

// src/molecules/Radio/RadioGroup.tsx
import { useUncontrolled } from "@mantine/hooks";
import { jsx as jsx33 } from "@emotion/react/jsx-runtime";
function RadioGroup(props) {
  const _a = props, {
    children,
    value,
    defaultValue,
    onChange,
    label,
    direction,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "children",
    "value",
    "defaultValue",
    "onChange",
    "label",
    "direction",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  const [internalValue, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "",
    onChange
  });
  return /* @__PURE__ */ jsx33(RadioGroupContext.Provider, { value: { value: internalValue, onChange: setValue }, children: /* @__PURE__ */ jsx33(InputGroupLayout, __spreadProps(__spreadValues({ role: "radiogroup", label, direction }, rest), { children })) });
}
__name(RadioGroup, "RadioGroup");

// src/molecules/Radio/Radio.tsx
import { jsx as jsx34 } from "@emotion/react/jsx-runtime";
var RADIO_COLOR_STYLES = {
  textColor: "systemGrayscale80",
  radioCheckedColor: "systemGrayscale80",
  radioUncheckedColor: "systemGrayscale60",
  disabledColor: "systemGrayscale30"
};
var getIconComponent = /* @__PURE__ */ __name((checked, disabled) => {
  if (disabled) {
    return checked ? RadioDisabledSelectedIcon : RadioDisabledUnselectedIcon;
  }
  return checked ? RadioSelectedIcon : RadioUnselectedIcon;
}, "getIconComponent");
function Radio(props) {
  const radioGroupContext = useRadioGroupContext();
  const theme = useTheme();
  const _a = props, {
    label,
    description,
    disabled,
    value,
    checked: externalChecked,
    onChange,
    css: css2,
    style,
    className
  } = _a, rest = __objRest(_a, [
    "label",
    "description",
    "disabled",
    "value",
    "checked",
    "onChange",
    /** The below props are omitted to prevent custom restyling */
    "css",
    "style",
    "className"
  ]);
  const checked = externalChecked || (radioGroupContext == null ? void 0 : radioGroupContext.value) === value;
  const { textColor, radioCheckedColor, radioUncheckedColor, disabledColor } = RADIO_COLOR_STYLES;
  const labelTypography = checked ? typography.bodyEmphasized : typography.bodyRegular;
  const Icon = getIconComponent(checked, disabled);
  const iconColor = disabled ? theme.colors[disabledColor] : checked ? theme.colors[radioCheckedColor] : theme.colors[radioUncheckedColor];
  const iconSize = 20;
  return /* @__PURE__ */ jsx34(
    MantineRadio,
    __spreadValues({
      styles: {
        body: {
          display: "flex"
        },
        label: __spreadValues({
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, labelTypography),
        labelWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: "4px"
        },
        description: __spreadValues({
          margin: "0px",
          color: disabled ? theme.colors[disabledColor] : theme.colors[textColor]
        }, typography.accentRegular),
        radio: {
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          appearance: "none",
          cursor: disabled ? "not-allowed" : "pointer",
          margin: 0
        },
        inner: {
          display: "flex",
          position: "relative"
        }
      },
      icon: () => /* @__PURE__ */ jsx34(
        Icon,
        {
          size: iconSize,
          css: {
            position: "absolute",
            inset: 0,
            pointerEvents: "none"
          },
          fill: iconColor
        }
      ),
      label,
      description,
      disabled,
      checked,
      value,
      onChange: disabled ? void 0 : (e) => {
        onChange == null ? void 0 : onChange(e.target.value);
        radioGroupContext == null ? void 0 : radioGroupContext.onChange(e.target.value);
      },
      unstyled: true
    }, rest)
  );
}
__name(Radio, "Radio");
Radio.Group = RadioGroup;

// src/molecules/Tabs/Tabs.tsx
import { Tabs as MantineTabs4 } from "@mantine/core";

// src/molecules/Tabs/Tab.tsx
import { forwardRef as forwardRef10 } from "react";
import { Tabs as MantineTabs } from "@mantine/core";
import { IssueIcon as IssueIcon2 } from "@instacart/ids-core";
import { jsx as jsx35 } from "@emotion/react/jsx-runtime";
var Tab = forwardRef10((props, ref) => {
  const theme = useTheme();
  const _a = props, {
    value,
    children,
    withWarning,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "value",
    "children",
    "withWarning",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx35(
    MantineTabs.Tab,
    __spreadProps(__spreadValues({
      ref,
      css: __spreadValues({
        "&[data-active]": __spreadValues({
          color: theme.colors.systemGrayscale80,
          borderColor: theme.colors.systemGrayscale80
        }, typography.bodyEmphasized),
        "&:not([data-active])": {
          color: theme.colors.systemGrayscale60,
          borderColor: theme.colors.systemGrayscale20
        },
        ":hover": {
          backgroundColor: "transparent"
        },
        ":focus-visible": {
          outline: `2px solid ${theme.colors.systemGrayscale80}`,
          outlineOffset: "2px"
        },
        padding: "12px 0",
        borderRadius: "unset"
      }, typography.bodyRegular),
      value,
      rightSection: withWarning ? /* @__PURE__ */ jsx35(
        IssueIcon2,
        {
          "data-testid": "tab-warning-icon",
          size: 16,
          fill: theme.colors.systemDetrimentalRegular
        }
      ) : void 0,
      color: theme.colors.systemGrayscale80,
      styles: {
        tabSection: {
          marginLeft: "8px"
        }
      },
      unstyled: true
    }, rest), {
      children: children || value
    })
  );
});

// src/molecules/Tabs/TabPanel.tsx
import { forwardRef as forwardRef11 } from "react";
import { Tabs as MantineTabs2 } from "@mantine/core";
import { jsx as jsx36 } from "@emotion/react/jsx-runtime";
var TabPanel = forwardRef11((props, ref) => {
  const _a = props, {
    value,
    children,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "value",
    "children",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx36(MantineTabs2.Panel, __spreadProps(__spreadValues({ value, ref }, rest), { children }));
});

// src/molecules/Tabs/TabList.tsx
import { forwardRef as forwardRef12 } from "react";
import { Tabs as MantineTabs3 } from "@mantine/core";
import { jsx as jsx37 } from "@emotion/react/jsx-runtime";
var TabList = forwardRef12((props, ref) => {
  const _a = props, {
    children,
    style: style,
    className,
    css: css2
  } = _a, rest = __objRest(_a, [
    "children",
    /** The below props are omitted to prevent custom restyling */
    "style",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ jsx37(MantineTabs3.List, __spreadProps(__spreadValues({ css: { maxWidth: "628px" }, ref }, rest), { children }));
});

// src/molecules/Tabs/Tabs.tsx
import { jsx as jsx38 } from "@emotion/react/jsx-runtime";
function Tabs(props) {
  const { value, defaultValue, onChange, children } = props;
  return /* @__PURE__ */ jsx38(
    MantineTabs4,
    {
      value,
      defaultValue,
      onChange,
      styles: {
        list: {
          gap: "16px",
          "--tab-border-color": "transparent"
        }
      },
      children
    }
  );
}
__name(Tabs, "Tabs");
Tabs.Tab = Tab;
Tabs.Panel = TabPanel;
Tabs.List = TabList;

// src/molecules/TextField/TextField.tsx
import { useState as useState6 } from "react";

// src/molecules/TextInputLabel/TextInputLabel.tsx
import { InformationIcon as InformationIcon2 } from "@instacart/ids-core";
import { Fragment as Fragment3, jsx as jsx39, jsxs as jsxs11 } from "@emotion/react/jsx-runtime";
var OPTIONAL_TEXT = "(optional)";
var gap = "1px";
var accentRegular = typography.accentRegular;
var bodyRegular = typography.bodyRegular;
var bodyEmphasized = typography.bodyEmphasized;
function TextInputLabel(props) {
  const theme = useTheme();
  const { label, optional, hint, labelTooltipProps, currentLength = 0, maxLength } = props;
  const charCounter = `${currentLength} / ${maxLength}`;
  return /* @__PURE__ */ jsxs11(Fragment3, { children: [
    /* @__PURE__ */ jsxs11(Flex.Row, { alignItems: "center", height: "20px", gap, children: [
      /* @__PURE__ */ jsx39("div", { css: __spreadValues({}, bodyEmphasized), children: label }),
      optional && /* @__PURE__ */ jsx39("div", { css: __spreadValues({ color: theme.colors.systemGrayscale60 }, bodyRegular), children: OPTIONAL_TEXT }),
      (labelTooltipProps == null ? void 0 : labelTooltipProps.label) && /* @__PURE__ */ jsx39(Tooltip, __spreadProps(__spreadValues({}, labelTooltipProps), { children: /* @__PURE__ */ jsx39(InformationIcon2, { cursor: "pointer", color: "systemGrayscale30" }) })),
      maxLength !== void 0 && /* @__PURE__ */ jsx39(
        "div",
        {
          css: __spreadValues({
            color: theme.colors.systemGrayscale60,
            marginLeft: "auto"
          }, accentRegular),
          children: charCounter
        }
      )
    ] }),
    hint && /* @__PURE__ */ jsx39("div", { css: __spreadValues({ color: theme.colors.systemGrayscale60, marginBottom: "2px" }, accentRegular), children: hint })
  ] });
}
__name(TextInputLabel, "TextInputLabel");

// src/molecules/TextInputBase/TextInputBase.tsx
import { css as EmotionCSS } from "@emotion/react";
import { jsx as jsx40 } from "@emotion/react/jsx-runtime";
function defaultOnChange(maxLength, setInputValue) {
  return (event) => {
    if (!(maxLength && event.target.value.length > maxLength)) {
      setInputValue(event.target.value);
    }
  };
}
__name(defaultOnChange, "defaultOnChange");
function useTextInputBase(props) {
  const theme = useTheme();
  const {
    disabled,
    compact,
    error,
    placeholderText,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    onLeftIconClick,
    rightIcon: RightIcon,
    onRightIconClick,
    inputValue,
    inputType,
    width = "100%"
  } = props;
  const textarea = inputType === "textarea" /* TEXTAREA */;
  const inputLeftPadding = LeftIcon ? spacing.s8 : readOnly ? "0px" : spacing.s16;
  const styles3 = {
    root: {
      width
    },
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      pointerEvents: "none",
      height: textarea ? "104px" : compact ? "28px" : "40px",
      boxSizing: "border-box"
    },
    label: {
      display: "block",
      color: theme.colors.systemGrayscale80
    },
    input: __spreadValues({
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      pointerEvents: "auto",
      height: "calc(100% - 22px)",
      width: `calc(100% - ${inputLeftPadding} - ${spacing.s8} - 2px)`,
      resize: "none",
      padding: `10px ${spacing.s8} 10px ${inputLeftPadding}`,
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
    }, inputValue && !readOnly ? typography.bodyEmphasized : typography.bodyRegular),
    section: {
      display: "flex",
      pointerEvents: "auto"
    }
  };
  const disabledOrReadOnly = disabled || readOnly;
  const focusErrorBorderColor = error ? theme.colors.systemDetrimentalRegular : theme.colors.brandPrimaryRegular;
  const activitySelectors = disabledOrReadOnly ? {} : {
    "&:hover": {
      borderColor: error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale60
    },
    "&:focus-within": {
      outlineWidth: "0",
      borderWidth: "1px",
      borderColor: focusErrorBorderColor,
      backgroundColor: theme.colors.systemGrayscale00
    },
    "&:focus": {
      borderWidth: "1px",
      borderColor: focusErrorBorderColor,
      outline: `2px solid ${theme.colors.systemGrayscale80}`,
      outlineOffset: "2px",
      backgroundColor: theme.colors.systemGrayscale00
    }
  };
  const css2 = EmotionCSS({
    [`div:has(${inputType})`]: __spreadValues({
      borderWidth: "1px",
      borderStyle: "solid",
      border: `1px solid ${readOnly ? theme.colors.systemGrayscale00 : disabled ? theme.colors.systemGrayscale20 : error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale30}`,
      borderRadius: radius.interactive,
      color: disabled ? theme.colors.systemGrayscale10 : theme.colors.systemGrayscale80,
      backgroundColor: disabled ? theme.colors.systemGrayscale10 : error ? `${theme.colors.systemDetrimentalLight}` : theme.colors.systemGrayscale00,
      cursor: disabled ? "not-allowed" : "auto"
    }, activitySelectors),
    [`${inputType}::placeholder, ${inputType}::-ms-input-placeholder `]: {
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
    }
  });
  return {
    styles: styles3,
    css: css2,
    disabled,
    error,
    placeholder: placeholderText,
    leftSection: LeftIcon && /* @__PURE__ */ jsx40(LeftIcon, { color: "systemGrayscale60" }),
    rightSection: RightIcon && /* @__PURE__ */ jsx40(RightIcon, { color: "systemGrayscale60" }),
    leftSectionProps: {
      style: { height: spacing.s16, paddingLeft: spacing.s8 },
      onClick: onLeftIconClick
    },
    rightSectionProps: {
      style: { height: spacing.s16, paddingRight: spacing.s8 },
      onClick: onRightIconClick
    },
    label: (labelProps == null ? void 0 : labelProps.label) && TextInputLabel(__spreadProps(__spreadValues({}, labelProps), { currentLength: inputValue.length })),
    value: inputValue
  };
}
__name(useTextInputBase, "useTextInputBase");

// src/molecules/TextInputBase/TextInputDescription.tsx
import { jsx as jsx41 } from "@emotion/react/jsx-runtime";
function TextInputDescription({
  description,
  error
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx41(
    "div",
    {
      css: __spreadValues({
        marginTop: "1px",
        color: error ? theme.colors.systemDetrimentalRegular : theme.colors.systemGrayscale60
      }, typography.accentRegular),
      children: description
    }
  );
}
__name(TextInputDescription, "TextInputDescription");

// src/molecules/TextField/TextField.tsx
import { TextInput as MantineTextInput } from "@mantine/core";
import { Fragment as Fragment4, jsx as jsx42, jsxs as jsxs12 } from "@emotion/react/jsx-runtime";
function TextField(props) {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    onChange: customOnChange,
    width
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "readOnly",
    "labelProps",
    "leftIcon",
    "rightIcon",
    "onChange",
    "width"
  ]);
  const [inputValue, setInputValue] = useState6("");
  const onChange = customOnChange || (readOnly ? void 0 : defaultOnChange(labelProps == null ? void 0 : labelProps.maxLength, setInputValue));
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    readOnly,
    labelProps,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    inputValue,
    inputType: "input" /* INPUT */,
    width
  });
  return /* @__PURE__ */ jsxs12(Fragment4, { children: [
    /* @__PURE__ */ jsx42(MantineTextInput, __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), { onChange, unstyled: true })),
    description && /* @__PURE__ */ jsx42(TextInputDescription, { description, error })
  ] });
}
__name(TextField, "TextField");

// src/molecules/TextArea/TextArea.tsx
import { useState as useState7 } from "react";
import { Textarea as MantineTextArea } from "@mantine/core";
import { Fragment as Fragment5, jsx as jsx43, jsxs as jsxs13 } from "@emotion/react/jsx-runtime";
function TextArea(props) {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    readOnly,
    labelProps,
    onChange: customOnChange,
    width
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "readOnly",
    "labelProps",
    "onChange",
    "width"
  ]);
  const [inputValue, setInputValue] = useState7("");
  const onChange = customOnChange || (readOnly ? void 0 : defaultOnChange(
    labelProps == null ? void 0 : labelProps.maxLength,
    setInputValue
  ));
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    readOnly,
    labelProps,
    inputValue,
    inputType: "textarea" /* TEXTAREA */,
    width
  });
  return /* @__PURE__ */ jsxs13(Fragment5, { children: [
    /* @__PURE__ */ jsx43(MantineTextArea, __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), { onChange, unstyled: true })),
    description && /* @__PURE__ */ jsx43(TextInputDescription, { description, error })
  ] });
}
__name(TextArea, "TextArea");

// src/molecules/SearchInput/SearchInput.tsx
import { useState as useState8 } from "react";
import { TextInput as MantineTextInput2 } from "@mantine/core";
import { SearchIcon, RemoveIcon } from "@instacart/ids-core";
import { Fragment as Fragment6, jsx as jsx44, jsxs as jsxs14 } from "@emotion/react/jsx-runtime";
function SearchInput(props) {
  const _a = props, {
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    description,
    labelProps,
    onSearch,
    onClear,
    onChange: customOnChange,
    width
  } = _a, rest = __objRest(_a, [
    "disabled",
    "compact",
    "error",
    "labelTooltipProps",
    "maxLength",
    "placeholderText",
    "description",
    "labelProps",
    "onSearch",
    "onClear",
    "onChange",
    "width"
  ]);
  const [inputValue, setInputValue] = useState8("");
  const onChange = customOnChange || defaultOnChange(labelProps == null ? void 0 : labelProps.maxLength, setInputValue);
  const renderProps = useTextInputBase({
    disabled,
    compact,
    error,
    labelTooltipProps,
    maxLength,
    placeholderText,
    labelProps,
    leftIcon: SearchIcon,
    onLeftIconClick: onSearch,
    rightIcon: RemoveIcon,
    onRightIconClick: onClear,
    inputValue,
    inputType: "input" /* INPUT */,
    width
  });
  return /* @__PURE__ */ jsxs14(Fragment6, { children: [
    /* @__PURE__ */ jsx44(MantineTextInput2, __spreadProps(__spreadValues(__spreadValues({}, renderProps), rest), { onChange, unstyled: true })),
    description && /* @__PURE__ */ jsx44(TextInputDescription, { description, error })
  ] });
}
__name(SearchInput, "SearchInput");

// src/molecules/SelectBase/SelectBase.tsx
import { ConfirmIcon, ChevronDownIcon as ChevronDownIcon3, ChevronUpIcon as ChevronUpIcon3 } from "@instacart/ids-core";
import { jsx as jsx45, jsxs as jsxs15 } from "@emotion/react/jsx-runtime";
var NO_RESULTS_MESSAGE = "No results";
var systemGrayscale30 = "systemGrayscale30";
var systemGrayscale60 = "systemGrayscale60";
var systemGrayscale80 = "systemGrayscale80";
var bodyRegular2 = typography.bodyRegular;
var accentRegular2 = typography.accentRegular;
function RenderOption(props) {
  const theme = useTheme();
  const { item, width, compact, multiSelect } = props;
  const { option, checked } = item;
  return /* @__PURE__ */ jsx45(
    "div",
    {
      style: __spreadValues({
        boxSizing: "border-box",
        width,
        height: "fit-content",
        minHeight: compact ? "30px" : "40px",
        padding: `${compact ? "6px" : "10px"} 16px`,
        color: option.disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
      }, bodyRegular2),
      css: {
        backgroundColor: checked ? theme.colors.brandPrimaryExtraLight : "transparent",
        "&:hover": {
          backgroundColor: theme.colors.brandPrimaryLight
        }
      },
      "data-testid": `${option.label}-option`,
      children: multiSelect ? /* @__PURE__ */ jsx45(
        Flex.Row,
        {
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "8px",
          css: { pointerEvents: "none" },
          children: /* @__PURE__ */ jsx45(Checkbox, { label: option.label, checked, "aria-hidden": true, tabIndex: -1 })
        }
      ) : /* @__PURE__ */ jsxs15(Flex.Row, { justifyContent: "space-between", alignItems: "center", children: [
        option.label,
        checked ? /* @__PURE__ */ jsx45("div", { style: { flexShrink: 0, height: "16px", width: "16px" }, children: /* @__PURE__ */ jsx45(ConfirmIcon, { color: systemGrayscale80 }) }) : null
      ] })
    }
  );
}
__name(RenderOption, "RenderOption");
var divHasInputSelector = "div:has(input)";
var focusFocusVisibleSelector = "&:focus, &:focus-visible";
var placeholderSelector = "&::placeholder";
var focusSelector = "&:focus";
var hoverSelector = "&:hover";
function useSelectBase(props) {
  const {
    dropdownOpened,
    closeDropdown,
    openDropdown,
    options,
    placeholder,
    disabled,
    compact,
    width = "200px",
    multiSelect = false
  } = props;
  const theme = useTheme();
  const height = compact ? "28px" : "40px";
  const iconColor = disabled ? systemGrayscale30 : systemGrayscale60;
  return {
    styles: {
      wrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        boxSizing: "border-box",
        height,
        width,
        minWidth: "142px",
        maxWidth: "400px",
        overflow: "hidden",
        minHeight: height
      },
      section: {
        height: "16px",
        width: "16px",
        display: "flex",
        alignItems: "center"
      },
      input: __spreadValues({
        boxSizing: "border-box",
        height: "100%",
        maxWidth: "calc(100% - 32px)",
        padding: "10px 8px 10px 16px",
        flex: "1",
        border: "unset",
        color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale80
      }, compact ? accentRegular2 : bodyRegular2),
      options: {
        width,
        boxSizing: "border-box",
        boxShadow: elevation.high.shadow.boxShadow,
        padding: "8px 0px",
        overflow: "unset",
        borderRadius: radius.interactive,
        marginTop: "2px",
        maxHeight: compact ? "316px" : "336px",
        overflowY: "auto",
        overflowX: "hidden"
      }
    },
    css: {
      [divHasInputSelector]: {
        backgroundColor: disabled ? theme.colors.systemGrayscale10 : "transparent",
        border: `1px solid ${disabled ? theme.colors.systemGrayscale20 : dropdownOpened ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale30}`,
        borderRadius: compact ? radius.interactiveCompact : radius.interactive,
        [hoverSelector]: {
          borderColor: disabled ? theme.colors.systemGrayscale20 : dropdownOpened ? theme.colors.brandPrimaryRegular : theme.colors.systemGrayscale60
        },
        [focusSelector]: {
          borderColor: disabled ? theme.colors.systemGrayscale20 : theme.colors.brandPrimaryRegular,
          outline: disabled ? "unset" : `2px solid ${theme.colors.systemGrayscale80}`,
          outlineOffset: disabled ? "unset" : "2px"
        }
      },
      input: {
        backgroundColor: "transparent",
        [focusFocusVisibleSelector]: {
          outline: "none"
        },
        [placeholderSelector]: {
          color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
        }
      }
    },
    data: options,
    withScrollArea: false,
    rightSection: dropdownOpened && !disabled ? /* @__PURE__ */ jsx45(
      ChevronUpIcon3,
      {
        color: iconColor,
        onClick: disabled ? void 0 : () => closeDropdown(),
        "data-testid": "chevron-up-icon"
      }
    ) : /* @__PURE__ */ jsx45(
      ChevronDownIcon3,
      {
        color: iconColor,
        onClick: disabled ? void 0 : () => openDropdown(),
        "data-testid": "chevron-down-icon"
      }
    ),
    renderOption: /* @__PURE__ */ __name((item) => RenderOption({ item, width, compact, multiSelect }), "renderOption"),
    placeholder,
    disabled,
    nothingFoundMessage: /* @__PURE__ */ jsx45(
      "div",
      {
        style: __spreadValues({
          boxSizing: "border-box",
          width,
          height,
          padding: "10px 16px",
          color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale60
        }, bodyRegular2),
        children: NO_RESULTS_MESSAGE
      }
    ),
    onDropdownClose: /* @__PURE__ */ __name(() => closeDropdown(), "onDropdownClose"),
    onDropdownOpen: /* @__PURE__ */ __name(() => openDropdown(), "onDropdownOpen"),
    dropdownOpened
  };
}
__name(useSelectBase, "useSelectBase");

// src/molecules/SelectField/SelectField.tsx
import { Select as MantineSelect, useCombobox } from "@mantine/core";
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
function SelectField(props) {
  var _b;
  const {
    options,
    placeholder,
    disabled,
    searchable,
    onChange,
    compact,
    allowDeselect = true,
    width
  } = props;
  const { dropdownOpened, closeDropdown, openDropdown } = useCombobox();
  const renderProps = useSelectBase({
    options,
    dropdownOpened,
    closeDropdown,
    openDropdown,
    placeholder,
    disabled,
    compact,
    width
  });
  const _a = renderProps, { styles: styles3 } = _a, rest = __objRest(_a, ["styles"]);
  return /* @__PURE__ */ jsx46(
    MantineSelect,
    __spreadProps(__spreadValues({
      styles: styles3,
      searchable,
      allowDeselect,
      defaultValue: allowDeselect ? "" : (_b = options.find((option) => option.disabled === false)) == null ? void 0 : _b.value
    }, rest), {
      onChange,
      unstyled: true
    })
  );
}
__name(SelectField, "SelectField");

// src/molecules/MultiselectDropdown/MultiselectDropdown.tsx
import { useState as useState9 } from "react";
import { Pill as MantinePill, Combobox, Input as Input2, PillsInput, useCombobox as useCombobox2 } from "@mantine/core";
import { jsx as jsx47, jsxs as jsxs16 } from "@emotion/react/jsx-runtime";
var bodyRegular3 = typography.bodyRegular;
var accentRegular3 = typography.accentRegular;
function MultiselectDropdown(props) {
  const { options, placeholder, disabled, onChange, compact, width } = props;
  const combobox = useCombobox2();
  const { dropdownOpened, closeDropdown, openDropdown } = combobox;
  const renderProps = useSelectBase({
    options,
    dropdownOpened,
    closeDropdown,
    openDropdown,
    placeholder,
    disabled,
    compact,
    multiSelect: true,
    width
  });
  const [value, setValue] = useState9([]);
  const handleValueSelect = /* @__PURE__ */ __name((val) => setValue((current) => {
    var _a;
    const label = (_a = options.find((option) => option.value === val)) == null ? void 0 : _a.label;
    if (label) {
      const newVal = current.includes(label) ? current.filter((v) => v !== label) : [...current, label];
      if (onChange) {
        onChange(newVal);
      }
      return newVal;
    }
    return current;
  }), "handleValueSelect");
  const handleValueRemove = /* @__PURE__ */ __name((val) => setValue((current) => {
    const newVal = current.filter((v) => v !== val);
    if (onChange) {
      onChange(newVal);
    }
    return newVal;
  }), "handleValueRemove");
  const values = value.map((item) => /* @__PURE__ */ jsx47(Pill, { onClose: () => handleValueRemove(item), "data-testid": item, children: item }, item));
  const renderOptions = options.map((option) => /* @__PURE__ */ jsx47(Combobox.Option, { value: option.value, active: value.includes(option.value), children: renderProps.renderOption({
    option,
    checked: value.includes(option.label)
  }) }, option.value));
  return /* @__PURE__ */ jsxs16(
    Combobox,
    {
      styles: {
        options: __spreadValues({}, renderProps.styles.options)
      },
      store: combobox,
      onOptionSubmit: handleValueSelect,
      withinPortal: false,
      disabled,
      unstyled: true,
      children: [
        /* @__PURE__ */ jsx47(Combobox.DropdownTarget, { children: /* @__PURE__ */ jsxs16(
          PillsInput,
          {
            styles: {
              root: __spreadProps(__spreadValues({}, renderProps.styles.wrapper), {
                height: "fit-content"
              }),
              wrapper: {
                height: "100%",
                width: "100%"
              },
              input: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "8px",
                paddingLeft: compact ? "12px" : "16px",
                paddingRight: "8px",
                maxWidth: "100%",
                border: "unset",
                outline: "unset"
              }
            },
            css: __spreadValues({}, renderProps.css["div:has(input)"]),
            unstyled: true,
            pointer: true,
            onClick: (event) => {
              const target = event.target;
              if (target.closest("button")) {
                return;
              }
              combobox.toggleDropdown();
            },
            children: [
              /* @__PURE__ */ jsxs16(
                MantinePill.Group,
                {
                  unstyled: true,
                  css: {
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "8px",
                    alignItems: "center",
                    flexGrow: 1,
                    height: "100%",
                    flexWrap: "wrap",
                    padding: compact ? "2px 0px" : "8px 0px"
                  },
                  children: [
                    values.length > 0 ? values : /* @__PURE__ */ jsx47(
                      Input2.Placeholder,
                      {
                        unstyled: true,
                        css: __spreadValues(__spreadValues({}, renderProps.css.input["&::placeholder"]), compact ? accentRegular3 : bodyRegular3),
                        children: renderProps.placeholder
                      }
                    ),
                    /* @__PURE__ */ jsx47(Combobox.EventsTarget, { children: /* @__PURE__ */ jsx47(
                      PillsInput.Field,
                      {
                        unstyled: true,
                        css: __spreadProps(__spreadValues(__spreadValues({}, renderProps.styles.input), renderProps.css.input), {
                          padding: "unset",
                          width: "0px",
                          marginLeft: "-4px",
                          caretColor: disabled ? "transparent" : "currentColor"
                        }),
                        type: "hidden",
                        onBlur: () => combobox.closeDropdown(),
                        onKeyDown: (event) => {
                          if (event.key === "Backspace") {
                            event.preventDefault();
                            handleValueRemove(value[value.length - 1]);
                          }
                        },
                        value: "",
                        onChange: () => {
                        }
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ jsx47("div", { style: __spreadValues({}, renderProps.styles.section), children: renderProps.rightSection })
            ]
          }
        ) }),
        /* @__PURE__ */ jsx47(Combobox.Dropdown, { "data-testid": "dropdown", children: /* @__PURE__ */ jsx47(Combobox.Options, { children: renderOptions }) })
      ]
    }
  );
}
__name(MultiselectDropdown, "MultiselectDropdown");

// src/molecules/Pagination/Pagination.tsx
import { ArrowRightIcon, ArrowLeftIcon } from "@instacart/ids-core";
import { jsx as jsx48, jsxs as jsxs17 } from "@emotion/react/jsx-runtime";
var bodyRegular4 = typography.bodyRegular;
function Pagination(props) {
  const theme = useTheme();
  const _a = props, {
    currentPage = "",
    onCurrentPageChange,
    totalPages,
    itemsPerPage,
    compact,
    backgroundColor = "systemGrayscale00",
    width = "100%",
    css: css2,
    className,
    style
  } = _a, rest = __objRest(_a, [
    "currentPage",
    "onCurrentPageChange",
    "totalPages",
    "itemsPerPage",
    "compact",
    "backgroundColor",
    "width",
    "css",
    "className",
    "style"
  ]);
  const borderRadius = compact ? radius.interactiveCompact : radius.interactive;
  const totalPagesLabel = `of ${totalPages}`;
  const borderProp = `1px solid ${theme.colors.systemGrayscale30}`;
  const compactLength = compact ? "28px" : "40px";
  const leftArrowDisabled = !currentPage || currentPage === 1;
  const leftIconSize = leftArrowDisabled ? 20 : 18;
  const rightArrowDisabled = currentPage === totalPages;
  const rightIconSize = rightArrowDisabled ? 20 : 18;
  return /* @__PURE__ */ jsx48(
    Flex.Row,
    __spreadProps(__spreadValues({
      css: __spreadValues({
        height: compact ? "44px" : "64px",
        boxSizing: "border-box",
        padding: "12px 8px",
        width,
        minWidth: "500px",
        backgroundColor: theme.colors[backgroundColor],
        color: theme.colors.systemGrayscale60,
        alignItems: "center"
      }, bodyRegular4)
    }, rest), {
      children: /* @__PURE__ */ jsxs17(Flex.Row, { justifyContent: "space-between", alignItems: "center", flexGrow: 1, children: [
        itemsPerPage && /* @__PURE__ */ jsxs17(
          Flex.Row,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            height: compactLength,
            children: [
              /* @__PURE__ */ jsx48("label", { htmlFor: "select", style: { width: "120px", textAlign: "right" }, children: itemsPerPage.label }),
              /* @__PURE__ */ jsx48(
                "select",
                {
                  id: "select",
                  style: {
                    borderRadius,
                    width: compact ? "57px" : "64px",
                    height: "100%",
                    padding: compact ? "5px 8px" : "10px 8px",
                    border: borderProp,
                    textAlign: "center"
                  },
                  css: {
                    "&:focus, &:focus-visible": {
                      outline: "none"
                    }
                  },
                  value: itemsPerPage.current,
                  onChange: (event) => itemsPerPage.onChange(Number(event.target.value)),
                  children: itemsPerPage.options.map((option) => /* @__PURE__ */ jsx48("option", { value: option, children: option }, option))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs17(
          Flex.Row,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
            height: compactLength,
            children: [
              /* @__PURE__ */ jsx48(
                IconButton,
                {
                  icon: ArrowLeftIcon,
                  compact,
                  variant: "secondary",
                  onClick: () => onCurrentPageChange(currentPage && currentPage - 1),
                  disabled: leftArrowDisabled,
                  size: leftIconSize
                }
              ),
              /* @__PURE__ */ jsx48(
                "input",
                {
                  value: currentPage,
                  onChange: (event) => {
                    const value = Number(event.target.value);
                    if (value >= 1 && value <= totalPages) {
                      onCurrentPageChange(value);
                    } else if (event.target.value === "") {
                      onCurrentPageChange("");
                    }
                  },
                  style: __spreadValues({
                    borderRadius,
                    height: "100%",
                    width: compactLength,
                    padding: "0",
                    boxSizing: "border-box",
                    border: borderProp,
                    textAlign: "center",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield"
                  }, typography.bodyEmphasized),
                  css: {
                    "input:focus, input:focus-visible": {
                      border: "unset"
                    },
                    "&:focus, &:focus-visible": {
                      outline: "none"
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsx48("div", { children: totalPagesLabel }),
              /* @__PURE__ */ jsx48(
                IconButton,
                {
                  icon: ArrowRightIcon,
                  compact,
                  variant: "secondary",
                  onClick: () => onCurrentPageChange(Number(currentPage) + 1),
                  disabled: rightArrowDisabled,
                  size: rightIconSize
                }
              )
            ]
          }
        )
      ] })
    })
  );
}
__name(Pagination, "Pagination");

// src/molecules/Divider/Divider.tsx
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
var getMeasurements = /* @__PURE__ */ __name((length) => {
  return {
    horizontal: {
      containerWidth: length,
      containerHeight: "16px",
      maxContainerHeight: "16px",
      dividerWidth: "100%",
      dividerHeight: "0px",
      dividerMargin: "8px 0px"
    },
    vertical: {
      containerWidth: "16px",
      maxContainerWidth: "16px",
      containerHeight: length,
      dividerWidth: "0px",
      dividerHeight: "100%",
      dividerMargin: "0px 8px"
    }
  };
}, "getMeasurements");
function Divider(props) {
  const theme = useTheme();
  const { orientation = "horizontal", visible = true, length = "100%" } = props;
  const measurements = getMeasurements(length);
  return /* @__PURE__ */ jsx49(
    "div",
    {
      style: {
        width: measurements[orientation].containerWidth,
        height: measurements[orientation].containerHeight
      },
      children: /* @__PURE__ */ jsx49(
        "div",
        {
          role: "separator",
          style: {
            boxSizing: "border-box",
            width: measurements[orientation].dividerWidth,
            height: measurements[orientation].dividerHeight,
            border: `1px solid ${visible ? theme.colors.systemGrayscale20 : theme.colors.systemGrayscale00}`,
            margin: measurements[orientation].dividerMargin
          }
        }
      )
    }
  );
}
__name(Divider, "Divider");

// src/molecules/Card/CardTitle.tsx
import { jsx as jsx50, jsxs as jsxs18 } from "@emotion/react/jsx-runtime";
function CardTitle(props) {
  const { title, icon: Icon } = props;
  return /* @__PURE__ */ jsxs18(
    Flex.Row,
    {
      gap: spacing.s24,
      justifyContent: "space-between",
      paddingBottom: spacing.s16,
      children: [
        title && /* @__PURE__ */ jsx50("div", { css: __spreadValues({ flexGrow: 1 }, typography.subtitle), "data-testid": "card-title-title", children: title }),
        Icon && /* @__PURE__ */ jsx50(Icon, { color: "systemGrayscale80", "data-testid": "card-title-icon", size: 24 })
      ]
    }
  );
}
__name(CardTitle, "CardTitle");

// src/molecules/Card/CardHeader.tsx
import { jsx as jsx51 } from "@emotion/react/jsx-runtime";
function CardHeader(props) {
  const { header } = props;
  return /* @__PURE__ */ jsx51("div", { css: __spreadValues({}, typography.headline), "data-testid": "card-header", children: header });
}
__name(CardHeader, "CardHeader");

// src/molecules/Card/CardStatus.tsx
import { jsx as jsx52, jsxs as jsxs19 } from "@emotion/react/jsx-runtime";
function CardStatus(props) {
  const { status, marker } = props;
  return /* @__PURE__ */ jsxs19(Flex.Row, { justifyContent: "space-between", children: [
    status && /* @__PURE__ */ jsx52("div", { css: __spreadValues({}, typography.accentRegular), "data-testid": "card-status-status", children: status }),
    marker && /* @__PURE__ */ jsx52(Marker, { variant: "neutral", text: marker })
  ] });
}
__name(CardStatus, "CardStatus");

// src/molecules/Card/CardLabel.tsx
import { jsx as jsx53, jsxs as jsxs20 } from "@emotion/react/jsx-runtime";
function CardLabel(props) {
  const { label, data } = props;
  return /* @__PURE__ */ jsxs20(Flex.Row, { justifyContent: "space-between", children: [
    /* @__PURE__ */ jsx53("div", { css: __spreadValues({}, typography.accentRegular), "data-testid": `card-label-label-${label}`, children: label }),
    /* @__PURE__ */ jsx53("div", { css: __spreadValues({}, typography.accentEmphasized), "data-testid": `card-label-data-${data}`, children: data })
  ] }, label);
}
__name(CardLabel, "CardLabel");

// src/molecules/Card/CardBody.tsx
import { jsx as jsx54 } from "@emotion/react/jsx-runtime";
function CardBody({ children }) {
  return /* @__PURE__ */ jsx54(Flex.Column, { gap: spacing.s16, children });
}
__name(CardBody, "CardBody");

// src/molecules/Card/Card.tsx
import { useTheme as useTheme5 } from "@instacart/ids-core";
import { jsx as jsx55 } from "@emotion/react/jsx-runtime";
function Card(props) {
  const theme = useTheme5();
  const _a = props, { width = "100%", css: css2, className, style, children } = _a, rest = __objRest(_a, ["width", "css", "className", "style", "children"]);
  return /* @__PURE__ */ jsx55(
    "div",
    __spreadProps(__spreadValues({
      css: {
        width,
        height: "auto",
        padding: spacing.s16,
        border: `1px solid ${theme.colors.systemGrayscale20}`
      }
    }, rest), {
      children
    })
  );
}
__name(Card, "Card");
Card.Body = CardBody;
Card.Title = CardTitle;
Card.Header = CardHeader;
Card.Status = CardStatus;
Card.Label = CardLabel;

// src/organisms/PageHeader/PageHeaderBackLink.tsx
import { ArrowLeftIcon as ArrowLeftIcon2 } from "@instacart/ids-core";
import { jsx as jsx56 } from "@emotion/react/jsx-runtime";
function PageHeaderBackLink(props) {
  const { backLink } = props;
  if (!backLink) return null;
  return /* @__PURE__ */ jsx56("div", { css: { marginBottom: spacing.s4, wordBreak: "break-word", overflowWrap: "break-word" }, children: /* @__PURE__ */ jsx56(
    LinkBase,
    __spreadProps(__spreadValues({}, backLink), {
      hideUnderline: true,
      styles: {
        textColor: "brandPrimaryRegular",
        activeColor: "brandPrimaryExtraDark",
        hoverColor: "brandPrimaryDark",
        focusColor: "systemGrayscale80",
        disabledColor: "systemGrayscale30"
      },
      leftIcon: ArrowLeftIcon2
    })
  ) });
}
__name(PageHeaderBackLink, "PageHeaderBackLink");

// src/organisms/PageHeader/PageHeaderTitle.tsx
import { jsx as jsx57 } from "@emotion/react/jsx-runtime";
function PageHeaderTitle(props) {
  const { title } = props;
  return /* @__PURE__ */ jsx57(
    "div",
    {
      css: __spreadProps(__spreadValues({}, typography.headline), {
        wordBreak: "break-word",
        overflowWrap: "break-word",
        paddingTop: spacing.s4,
        paddingBottom: spacing.s4
      }),
      children: title.text
    }
  );
}
__name(PageHeaderTitle, "PageHeaderTitle");

// src/organisms/PageHeader/PageHeaderStatus.tsx
import { jsx as jsx58, jsxs as jsxs21 } from "@emotion/react/jsx-runtime";
function PageHeaderStatus(props) {
  const { marker, updatedAt } = props;
  if (!marker && !updatedAt) return null;
  return /* @__PURE__ */ jsxs21(Flex.Row, { alignItems: "center", gap: 16, children: [
    marker && /* @__PURE__ */ jsx58(Marker, __spreadValues({}, marker)),
    updatedAt && /* @__PURE__ */ jsxs21("div", { css: typography.accentRegular, children: [
      "Updated ",
      updatedAt.text
    ] })
  ] });
}
__name(PageHeaderStatus, "PageHeaderStatus");

// src/organisms/PageHeader/PageHeaderActions.tsx
import { OptionsIcon } from "@instacart/ids-core";
import { jsx as jsx59, jsxs as jsxs22 } from "@emotion/react/jsx-runtime";
function PageHeaderActions(props) {
  const { actions } = props;
  if (!actions) return null;
  return /* @__PURE__ */ jsxs22(Button2.Group, { children: [
    actions.overflowMenu && /* @__PURE__ */ jsx59(IconButtonMenu, { variant: "tertiary", icon: OptionsIcon, children: actions.overflowMenu.map((item) => {
      if (item.type === "header") {
        return /* @__PURE__ */ jsx59(MenuHeader, __spreadValues({}, item));
      }
      return /* @__PURE__ */ jsx59(MenuItem, __spreadValues({}, item));
    }) }),
    (actions == null ? void 0 : actions.secondary) && /* @__PURE__ */ jsx59(Button2, { variant: "secondary", onClick: actions.secondary.onClick, children: actions.secondary.label }),
    (actions == null ? void 0 : actions.primary) && /* @__PURE__ */ jsx59(Button2, { variant: "primary", onClick: actions.primary.onClick, children: actions.primary.label })
  ] });
}
__name(PageHeaderActions, "PageHeaderActions");

// src/organisms/PageHeader/PageHeaderAlert.tsx
import { jsx as jsx60 } from "@emotion/react/jsx-runtime";
function PageHeaderAlert(props) {
  const { alert } = props;
  if (!alert) return null;
  return /* @__PURE__ */ jsx60("div", { css: { marginBottom: spacing.s8 }, children: /* @__PURE__ */ jsx60(Alert, __spreadProps(__spreadValues({}, alert), { children: alert.text })) });
}
__name(PageHeaderAlert, "PageHeaderAlert");

// src/organisms/PageHeader/PageHeaderTabs.tsx
import { useEffect as useEffect4, useState as useState11 } from "react";

// src/organisms/PageHeader/PageHeaderProvider.tsx
import { useState as useState10, createContext as createContext2, useContext as useContext3 } from "react";
import { jsx as jsx61 } from "@emotion/react/jsx-runtime";
var PageHeaderContext = createContext2(void 0);
function usePageHeader() {
  const context = useContext3(PageHeaderContext);
  return context;
}
__name(usePageHeader, "usePageHeader");
function PageHeaderProvider({ children }) {
  const [tab, setTab] = useState10(null);
  return /* @__PURE__ */ jsx61(PageHeaderContext.Provider, { value: { tab, setTab }, children });
}
__name(PageHeaderProvider, "PageHeaderProvider");

// src/organisms/PageHeader/PageHeaderTabs.tsx
import { jsx as jsx62 } from "@emotion/react/jsx-runtime";
function PageHeaderTabs(props) {
  const pageHeaderContext = usePageHeader();
  const { tabs } = props;
  const [tabValue, setTabValue] = useState11((tabs == null ? void 0 : tabs[0].value) || null);
  useEffect4(() => {
    if (pageHeaderContext) {
      pageHeaderContext == null ? void 0 : pageHeaderContext.setTab(tabValue);
    }
  }, [tabValue, pageHeaderContext]);
  if (!tabs) return null;
  return /* @__PURE__ */ jsx62(Tabs, { defaultValue: tabs[0].value, value: tabValue, onChange: (newTab) => setTabValue(newTab), children: /* @__PURE__ */ jsx62(Tabs.List, { children: tabs.map((tab) => /* @__PURE__ */ jsx62(Tabs.Tab, __spreadProps(__spreadValues({}, tab), { children: tab.label }), tab.value)) }) });
}
__name(PageHeaderTabs, "PageHeaderTabs");

// src/organisms/PageHeader/PageHeader.tsx
import { jsx as jsx63, jsxs as jsxs23 } from "@emotion/react/jsx-runtime";
function PageHeader(props) {
  return /* @__PURE__ */ jsxs23("div", { css: { padding: "24px 80px" }, children: [
    /* @__PURE__ */ jsx63(PageHeaderBackLink, __spreadValues({}, props)),
    /* @__PURE__ */ jsxs23(Flex.Row, { css: { marginBottom: spacing.s8 }, children: [
      /* @__PURE__ */ jsxs23(
        Flex.Row,
        {
          alignItems: "center",
          flexGrow: 1,
          flexWrap: "wrap",
          gap: 16,
          marginRight: 16,
          css: {
            rowGap: spacing.s4
          },
          children: [
            /* @__PURE__ */ jsx63(PageHeaderTitle, __spreadValues({}, props)),
            /* @__PURE__ */ jsx63(PageHeaderStatus, __spreadValues({}, props))
          ]
        }
      ),
      /* @__PURE__ */ jsx63(PageHeaderActions, __spreadValues({}, props))
    ] }),
    /* @__PURE__ */ jsx63(PageHeaderAlert, __spreadValues({}, props)),
    /* @__PURE__ */ jsx63(PageHeaderTabs, __spreadValues({}, props))
  ] });
}
__name(PageHeader, "PageHeader");

// src/organisms/PageHeader/PageHeaderTabPanel.tsx
import { jsx as jsx64 } from "@emotion/react/jsx-runtime";
function PageHeaderTabPanel({ value, children }) {
  const context = usePageHeader();
  return /* @__PURE__ */ jsx64(Tabs, { value: context == null ? void 0 : context.tab, children: /* @__PURE__ */ jsx64(Tabs.Panel, { value, children }) });
}
__name(PageHeaderTabPanel, "PageHeaderTabPanel");
export {
  Alert,
  Button2 as Button,
  ButtonBase,
  ButtonMenu,
  ButtonText,
  Card,
  CategoryPill,
  Checkbox,
  CheckboxBase,
  CloseButton,
  Divider,
  Flex,
  IconButton,
  IconButtonMenu,
  Link,
  LinkBase,
  LoadingDots,
  Marker,
  MarkerBase,
  MenuBase,
  MenuHeader,
  MenuItem,
  MenuPosition,
  MultiselectDropdown,
  PageHeader,
  PageHeaderProvider,
  PageHeaderTabPanel,
  Pagination,
  Pill,
  PillGroup,
  Radio,
  RadioGroup,
  SearchInput,
  SelectField,
  SelectionPill,
  SingleDatePicker,
  SwitchToggle,
  TDS_DEFAULT_COLORS,
  Tab,
  Tabs,
  TdsProvider,
  TextArea,
  TextField,
  Tooltip,
  elevation,
  radius,
  spacing,
  typography,
  usePageHeader,
  useTheme
};
